(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-grow-creator"] && !Shopify.designMode) return;
  try {
    
  class CustomGrowCreator extends HTMLElement {
    connectedCallback() {
      this.systemSelect = this.querySelector('[data-system-select]');
      this.submit = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.recipePreview = this.querySelector('[data-recipe-preview]');
      this.systemSelect?.addEventListener('change', () => this.updateSystem());
      this.querySelectorAll('[data-addon]').forEach((input) => input.addEventListener('change', () => this.updateSummary()));
      this.submit?.addEventListener('click', () => this.addToCart());
      document.querySelectorAll('substrate-configurator [data-mix-part]').forEach((input) => input.addEventListener('input', () => this.updateRecipe()));
      this.updateRecipe();
      this.updateSummary();
    }
    get recipe() {
      return document.querySelector('substrate-configurator [data-recipe]')?.value?.trim() || '';
    }
    get recipeTotal() {
      return [...document.querySelectorAll('substrate-configurator [data-mix-part]')].reduce((sum, input) => sum + Number(input.value), 0);
    }
    updateRecipe() {
      this.recipePreview.textContent = this.recipe || this.dataset.recipeMissing;
      this.updateSummary();
    }
    updateSystem() {
      this.querySelectorAll('[data-system-panel]').forEach((panel) => { panel.hidden = panel.dataset.systemPanel !== this.systemSelect.value; });
      this.updateSummary();
    }
    updateSummary() {
      const items = this.querySelectorAll('[data-summary-list] li');
      const mixVariant = this.querySelector('[data-mix-variant] option:checked');
      const systemOption = this.systemSelect?.selectedOptions[0];
      const addons = [...this.querySelectorAll('[data-addon]:checked')].map((input) => input.closest('label').querySelector('strong').textContent.trim());
      if (items[0] && mixVariant) items[0].textContent = `Substratmischung: ${mixVariant.dataset.litres}`;
      if (items[1]) items[1].textContent = systemOption?.value ? `Topfsystem: ${systemOption.textContent.trim()}` : 'Topfsystem noch auswählen';
      if (items[2]) items[2].textContent = addons.length ? `Add-ons: ${addons.join(', ')}` : 'Keine Add-ons ausgewählt';
    }
    async addToCart() {
      const mixVariant = this.querySelector('[data-mix-variant]')?.value;
      const systemPanel = this.querySelector(`[data-system-panel="${this.systemSelect?.value}"]`);
      const systemVariant = systemPanel?.querySelector('[data-system-variant]')?.value;
      if (!mixVariant || !systemVariant) {
        this.status.textContent = 'Bitte wähle eine Substratgröße und ein Topfsystem.';
        return;
      }
      if (!this.recipe || this.recipeTotal !== 100) {
        this.status.textContent = this.dataset.recipeMissing;
        return;
      }
      const items = [{ id: Number(mixVariant), quantity: 1, properties: { 'Individuelle Rezeptur': this.recipe, 'Mischung gesamt': '100 %' } }, { id: Number(systemVariant), quantity: 1 }];
      this.querySelectorAll('[data-addon]:checked').forEach((input) => { if (input.value) items.push({ id: Number(input.value), quantity: 1 }); });
      this.submit.disabled = true;
      this.status.textContent = 'Dein Grow-Setup wird zusammengestellt …';
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Cart request failed');
        this.status.textContent = this.dataset.validMessage;
        window.location.href = this.dataset.cartUrl;
      } catch (error) {
        this.status.textContent = 'Das Setup konnte nicht hinzugefügt werden. Bitte prüfe die Verfügbarkeit.';
        this.submit.disabled = false;
      }
    }
  }
  if (!customElements.get('custom-grow-creator')) customElements.define('custom-grow-creator', CustomGrowCreator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const desktopBreakpoint = 1240;

    const initDesktopMenu = (header) => {
      if (header.desktopMenuController) return;
      const nav = header.querySelector('.site-header__desktop');
      if (!nav) return;
      const controller = new AbortController();
      header.desktopMenuController = controller;
      const { signal } = controller;
      const menus = [...nav.querySelectorAll('[data-desktop-menu]')];
      const closeMenus = (except) => menus.forEach((menu) => {
        if (menu !== except) menu.open = false;
      });
      menus.forEach((menu) => menu.addEventListener('toggle', () => {
        if (menu.open) closeMenus(menu);
      }, { signal }));
      document.addEventListener('pointerdown', (event) => {
        if (!nav.contains(event.target)) closeMenus();
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const openMenu = menus.find((menu) => menu.open);
        if (openMenu) {
          closeMenus();
          openMenu.querySelector('summary').focus();
        }
      }, { signal });
      nav.addEventListener('focusout', (event) => {
        if (!nav.contains(event.relatedTarget)) closeMenus();
      }, { signal });
      window.addEventListener('resize', () => {
        if (window.innerWidth <= desktopBreakpoint) closeMenus();
      }, { signal });
    };

    const initMobileMenu = (header) => {
      if (header.dataset.mobileMenuReady === 'true') return;

      const menu = header.querySelector('[data-mobile-menu]');
      const summary = menu?.querySelector(':scope > summary');
      const panel = menu?.querySelector('[data-mobile-menu-panel]');
      if (!menu || !summary || !panel) return;

      header.dataset.mobileMenuReady = 'true';
      const controller = new AbortController();
      const { signal } = controller;
      header.mobileMenuController = controller;

      const setPanelHeight = () => {
        const viewport = window.visualViewport;
        const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        const headerBottom = header.getBoundingClientRect().bottom;
        header.style.setProperty('--site-header-menu-height', `${Math.max(0, viewportBottom - headerBottom)}px`);
      };

      const closeSubmenus = () => {
        panel.querySelectorAll('.site-header__mobile-disclosure[open]').forEach((disclosure) => {
          disclosure.removeAttribute('open');
        });
      };

      const unlockPage = () => {
        document.documentElement.classList.remove('site-header-menu-open');
        document.documentElement.style.removeProperty('--site-header-scrollbar-width');
      };

      const closeMenu = (restoreFocus = false) => {
        menu.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        summary.setAttribute('aria-label', summary.dataset.openLabel);
        closeSubmenus();
        unlockPage();
        if (restoreFocus) summary.focus();
      };

      const syncMenu = () => {
        const isOpen = menu.open && window.innerWidth <= desktopBreakpoint;
        if (!isOpen) {
          closeMenu();
          return;
        }

        document.querySelectorAll('[data-mobile-menu][open]').forEach((otherMenu) => {
          if (otherMenu !== menu) otherMenu.removeAttribute('open');
        });
        const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        document.documentElement.style.setProperty('--site-header-scrollbar-width', `${scrollbarWidth}px`);
        document.documentElement.classList.add('site-header-menu-open');
        summary.setAttribute('aria-expanded', 'true');
        summary.setAttribute('aria-label', summary.dataset.closeLabel);
        setPanelHeight();
      };

      closeMenu();
      menu.addEventListener('toggle', syncMenu, { signal });
      panel.addEventListener('click', (event) => {
        if (event.target.closest('a')) closeMenu();
      }, { signal });
      document.addEventListener('pointerdown', (event) => {
        if (menu.open && !menu.contains(event.target)) closeMenu();
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) closeMenu(true);
      }, { signal });
      window.addEventListener('resize', () => {
        if (window.innerWidth > desktopBreakpoint) closeMenu();
        else if (menu.open) setPanelHeight();
      }, { signal });
      window.addEventListener('pageshow', () => closeMenu(), { signal });
      window.visualViewport?.addEventListener('resize', setPanelHeight, { signal });
    };

    const initMobileSearch = (header) => {
      if (header.dataset.mobileSearchReady === 'true') return;
      const form = header.querySelector('[data-header-search]');
      const input = form?.querySelector('input[type="search"]');
      const toggle = form?.querySelector('[data-search-toggle]');
      if (!form || !input || !toggle) return;

      header.dataset.mobileSearchReady = 'true';

      const closeSearch = () => {
        form.classList.remove('is-open');
        input.blur();
      };

      toggle.addEventListener('click', (event) => {
        if (window.innerWidth > desktopBreakpoint) return;
        if (!form.classList.contains('is-open')) {
          event.preventDefault();
          header.querySelector('[data-mobile-menu]')?.removeAttribute('open');
          document.documentElement.classList.remove('site-header-menu-open');
          form.classList.add('is-open');
          requestAnimationFrame(() => input.focus());
          return;
        }
        if (!input.value.trim()) {
          event.preventDefault();
          closeSearch();
        }
      });

      document.addEventListener('pointerdown', (event) => {
        if (form.classList.contains('is-open') && !form.contains(event.target)) closeSearch();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && form.classList.contains('is-open')) closeSearch();
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth > desktopBreakpoint) closeSearch();
      });
    };

    const initAllMobileMenus = (root = document) => {
      root.querySelectorAll('[data-site-header]').forEach((header) => {
        initDesktopMenu(header);
        initMobileMenu(header);
        initMobileSearch(header);
      });
    };

    initAllMobileMenus();
    document.addEventListener('shopify:section:load', (event) => initAllMobileMenus(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const header = event.target.querySelector('[data-site-header]');
      if (!header) return;
      header.mobileMenuController?.abort();
      header.desktopMenuController?.abort();
      document.documentElement.classList.remove('site-header-menu-open');
      document.documentElement.style.removeProperty('--site-header-scrollbar-width');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection-journey"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-journey]').forEach((root) => {
    const buttons = [...root.querySelectorAll('[data-journey-filter]')];
    const cards = [...root.querySelectorAll('[data-journey-card]')];
    const status = root.querySelector('[data-journey-status]');
    const empty = root.querySelector('[data-journey-empty]');
    const prefix = root.dataset.resultPrefix || '';
    const suffix = root.dataset.resultSuffix || '';

    const update = (filter) => {
      let visible = 0;
      cards.forEach((card) => {
        const isVisible = filter === 'all' || card.dataset.category === filter;
        card.hidden = !isVisible;
        card.setAttribute('aria-hidden', String(!isVisible));
        if (isVisible) visible += 1;
      });
      buttons.forEach((button) => {
        const isActive = button.dataset.journeyFilter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
      if (status) status.textContent = `${prefix} ${visible} ${suffix}`.trim();
      if (empty) empty.hidden = visible !== 0;
    };

    buttons.forEach((button) => button.addEventListener('click', () => update(button.dataset.journeyFilter)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-discovery-path"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-home-discovery]').forEach((section)=>{const buttons=section.querySelectorAll('[data-filter]');const items=section.querySelectorAll('[data-item]');const empty=section.querySelector('[data-empty]');buttons.forEach((button)=>button.addEventListener('click',()=>{const filter=button.dataset.filter;let count=0;buttons.forEach((item)=>{const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',active?'true':'false')});items.forEach((item)=>{const show=filter==='all'||item.dataset.topic===filter;item.hidden=!show;if(show)count++});empty.hidden=count>0}))});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leaf-labs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const endpoint = 'https://vbqimcwaxcydegqlkkgw.supabase.co/functions/v1/public-labs';

    const refresh = async (root) => {
      if (!root) return;

      try {
        const response = await fetch(endpoint, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });

        if (!response.ok) return;

        const payload = await response.json();
        const metrics = payload && payload.metrics ? payload.metrics : {};
        const capabilities = new Set(Array.isArray(payload.capabilities) ? payload.capabilities : []);

        root.querySelectorAll('[data-labs-key]').forEach((card) => {
          card.hidden = !capabilities.has(card.dataset.labsKey);
        });

        const commerce = root.querySelector('[data-labs-value="commerce-platform"]');
        const commerceValue = Number(metrics.commerce_records_floor);
        if (commerce && Number.isFinite(commerceValue)) {
          const plus = metrics.commerce_records_rounded ? '+' : '';
          commerce.textContent = `${commerceValue}${plus} ${commerce.dataset.suffix || ''}`.trim();
        }

        const analytics = root.querySelector('[data-labs-value="data-analytics"]');
        const reportingDays = Number(metrics.reporting_days);
        if (analytics && Number.isFinite(reportingDays)) {
          analytics.textContent = `${reportingDays} ${analytics.dataset.suffix || ''}`.trim();
        }

        const automation = root.querySelector('[data-labs-value="ai-automation"]');
        if (automation && typeof metrics.multiple_controlled_workflows === 'boolean') {
          automation.textContent = metrics.multiple_controlled_workflows
            ? automation.dataset.multiple || ''
            : automation.dataset.single || '';
        }

        const development = root.querySelector('[data-labs-value="ai-native-development"]');
        if (development && metrics.ai_native_active === true) {
          development.textContent = development.dataset.active || '';
        }

        const freshness = root.querySelector('[data-labs-freshness]');
        if (freshness && payload.generated_at) {
          const generatedAt = new Date(payload.generated_at);
          if (!Number.isNaN(generatedAt.getTime())) {
            const formatted = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
              dateStyle: 'medium',
              timeStyle: 'short'
            }).format(generatedAt);
            freshness.textContent = `${freshness.dataset.label || ''} ${formatted}`.trim();
          }
        }
      } catch {
        return;
      }
    };

    document.querySelectorAll('[data-leaf-labs]').forEach((root) => refresh(root));

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-leaf-labs]')
        ? event.target
        : event.target.querySelector('[data-leaf-labs]');
      refresh(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leaf-led-home-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const hydrate = (scope) => {
    scope.querySelectorAll('[data-leaf-led-home]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const buttons = [...root.querySelectorAll('[data-led-choice]')];
      const link = root.querySelector('[data-led-destination]');
      const heading = root.querySelector('[data-led-output-title]');
      const explanation = root.querySelector('[data-led-output-text]');
      buttons.forEach((button) => button.addEventListener('click', () => {
        const key = button.dataset.ledChoice;
        const copy = root.querySelector('[data-led-content="' + key + '"]');
        if (!copy || !link || !heading || !explanation) return;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        heading.textContent = copy.dataset.ledCopyTitle || '';
        explanation.textContent = copy.dataset.ledCopyDescription || '';
        link.href = link.dataset.ledBase + '?led_use=' + encodeURIComponent(key) + '#LedFinder';
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => hydrate(document), { once: true });
  else hydrate(document);
  document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leaf-project-configurator"] && !Shopify.designMode) return;
  try {
    
  class LeafProjectConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const read = (selector) => { try { return JSON.parse(this.querySelector(selector)?.textContent || '[]'); } catch { return []; } };
      this.profiles = read('[data-project-profiles]');
      this.recipes = read('[data-project-recipes]');
      this.rules = read('[data-project-rules]');
      this.form = this.querySelector('[data-project-form]');
      this.form?.addEventListener('submit', (event) => { event.preventDefault(); this.update(); });
    }
    matches(rule, state) {
      const conditions = rule?.conditions || {};
      return Object.entries(conditions).every(([key,value]) => {
        if (value === null || value === '' || value === 'any') return true;
        const current = state[key];
        return Array.isArray(value) ? value.includes(current) : String(value) === String(current);
      });
    }
    update() {
      const plant = this.querySelector('[data-project-plant]')?.value || '';
      const state = {
        plant,
        light: this.querySelector('[data-project-light]')?.value || 'medium',
        watering: this.querySelector('[data-project-watering]')?.value || 'normal',
        system: this.querySelector('[data-project-system]')?.value || 'classic',
        volume: this.querySelector('[data-project-volume]')?.value || '5'
      };
      const profile = this.profiles.find((item) => item.handle === plant);
      if (!profile) return;
      state.group = profile.group;
      let candidates = this.recipes.filter((recipe) => String(recipe.group).toLowerCase() === String(profile.group).toLowerCase());
      if (!candidates.length) candidates = this.recipes;
      const recipe = candidates.sort((a,b) => this.score(b, profile, state) - this.score(a, profile, state))[0];
      const title = this.querySelector('[data-project-title]');
      const copy = this.querySelector('[data-project-copy]');
      if (title) title.textContent = recipe?.name || profile.name;
      if (copy) copy.textContent = recipe?.explanation || profile.note || profile.name;
      this.renderMetrics(recipe || profile);
      this.renderWhy(profile, recipe, state);
      this.renderRecipe(recipe, state.volume);
      this.renderAddons(state);
      const pro = this.querySelector('[data-project-pro]');
      if (pro) pro.hidden = false;
    }
    score(recipe, profile, state) {
      let score = 100 - Math.abs(Number(recipe.aeration || 5) - Number(profile.aeration || 5)) * 4 - Math.abs(Number(recipe.drainage || 5) - Number(profile.drainage || 5)) * 4 - Math.abs(Number(recipe.water || 5) - Number(profile.water || 5)) * 4;
      if (Array.isArray(recipe.systems) && recipe.systems.length && recipe.systems.includes(state.system)) score += 15;
      if (state.watering === 'frequent') score += Number(recipe.drainage || 0) * 1.5;
      if (state.watering === 'rare') score += Number(recipe.water || 0) * 1.5;
      return score;
    }
    renderWhy(profile, recipe, state) {
      const node = this.querySelector('[data-project-why]');
      if (!node) return;
      node.replaceChildren();
      const reasons = [];
      reasons.push({ title: profile.name, text: profile.note || `Zielprofil: Luftigkeit ${profile.aeration}/10, Drainage ${profile.drainage}/10, Wasserspeicher ${profile.water}/10.` });
      if (state.watering === 'frequent') reasons.push({ title: 'Gießverhalten', text: `Häufiges Gießen erhöht das Risiko dauerhaft nasser Poren. Deshalb wird Drainage stärker gewichtet${recipe ? `; diese Mischung erreicht ${recipe.drainage}/10` : ''}.` });
      if (state.watering === 'rare') reasons.push({ title: 'Gießverhalten', text: `Bei größeren Gießabständen wird Wasserspeicherung stärker gewichtet${recipe ? `; diese Mischung erreicht ${recipe.water}/10` : ''}.` });
      if (state.watering === 'normal') reasons.push({ title: 'Gießverhalten', text: 'Bei normalem Gießrhythmus bleibt die Balance aus Luft, Drainage und Feuchtepuffer im Vordergrund.' });
      if (state.system === 'self_watering') reasons.push({ title: 'Topfsystem', text: 'Selbstbewässerung verändert die Wasserverfügbarkeit dauerhaft. Geeignete Rezepturen für dieses System erhalten deshalb Vorrang.' });
      if (state.system === 'semi_hydro') reasons.push({ title: 'Topfsystem', text: 'Semi-Hydro verlangt eine besonders kontrollierbare, strukturstabile Wurzelzone. Systemgeeignete Rezepturen werden bevorzugt.' });
      if (state.system === 'fabric') reasons.push({ title: 'Topfsystem', text: 'Stofftöpfe trocknen durch ihre hohe Verdunstungsfläche schneller. Die Empfehlung berücksichtigt deshalb den Feuchtepuffer.' });
      if (state.system === 'classic') reasons.push({ title: 'Topfsystem', text: 'Im klassischen Topf entscheidet vor allem das Verhältnis aus Drainage, Luftporen und Wasserspeicher.' });
      if (state.light === 'high') reasons.push({ title: 'Licht', text: 'Viel Licht kann Wasserverbrauch und Wachstum erhöhen. Die Empfehlung wird deshalb nicht isoliert vom Gießverhalten betrachtet.' });
      if (state.light === 'low') reasons.push({ title: 'Licht', text: 'Bei wenig Licht ist der Wasserverbrauch häufig geringer. Eine zu lange nasse Wurzelzone soll deshalb vermieden werden.' });
      if (recipe?.explanation) reasons.push({ title: 'Rezeptentscheidung', text: recipe.explanation });
      const heading=document.createElement('strong'); heading.className='leaf-project__why-title'; heading.textContent='Warum diese Empfehlung?';
      const intro=document.createElement('p'); intro.className='leaf-project__why-intro'; intro.textContent='Die Empfehlung wird aus deinen Angaben und dem hinterlegten Pflanzen- und Rezeptprofil abgeleitet.';
      const list=document.createElement('ol');
      reasons.slice(0,6).forEach((reason) => { const li=document.createElement('li'); const b=document.createElement('b'); b.textContent=reason.title; const span=document.createElement('span'); span.textContent=reason.text; li.append(b,span); list.append(li); });
      node.append(heading,intro,list); node.hidden=false;
    }
    renderMetrics(item) {
      const node = this.querySelector('[data-project-metrics]');
      if (!node) return;
      node.replaceChildren();
      [['Luftigkeit',item.aeration],['Drainage',item.drainage],['Wasserspeicher',item.water],['Struktur',item.structure]].forEach(([label,value]) => {
        if (value === undefined || value === null || value === '') return;
        const span = document.createElement('span'); span.textContent = `${label} ${value}/10`; node.append(span);
      });
      node.hidden = !node.children.length;
    }
    renderRecipe(recipe, volume) {
      const node = this.querySelector('[data-project-recipe]');
      if (!node) return;
      node.replaceChildren();
      const composition = recipe?.composition;
      if (!composition || typeof composition !== 'object') { node.hidden = true; return; }
      node.className = 'leaf-project__recipe';
      const strong = document.createElement('strong'); strong.textContent = `${volume} L · Mischung`;
      const list = document.createElement('ul');
      Object.entries(composition).forEach(([name,share]) => { const li=document.createElement('li'); li.textContent=`${name}: ${share}% · ${(Number(volume)*Number(share)/100).toLocaleString(undefined,{maximumFractionDigits:2})} L`; list.append(li); });
      node.append(strong,list); node.hidden = false;
    }
    renderAddons(state) {
      const node = this.querySelector('[data-project-addons]');
      if (!node) return;
      node.replaceChildren();
      this.rules.filter((rule) => this.matches(rule,state)).sort((a,b) => Number(b.priority||0)-Number(a.priority||0)).slice(0,4).forEach((rule) => {
        if (!rule.product) return;
        const link=document.createElement('a'); link.className='leaf-project__addon'; link.href=rule.product.url;
        const title=document.createElement('strong'); title.textContent=rule.product.title;
        const reason=document.createElement('small'); reason.textContent=rule.reason || '';
        link.append(title,reason); node.append(link);
      });
      node.hidden = !node.children.length;
    }
  }
  if (!customElements.get('leaf-project-configurator')) customElements.define('leaf-project-configurator', LeafProjectConfigurator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leafer-substrate-selector"] && !Shopify.designMode) return;
  try {
    
  class LeaferSubstrateSelector extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.nativeSelect = this.querySelector('[data-variant-select]');
      this.nativeField = this.querySelector('[data-native-field]');
      this.profileChoices = [...this.querySelectorAll('[data-profile-choice]')];
      this.volumeChoices = [...this.querySelectorAll('[data-volume-choice]')];
      this.variants = this.parseData('[data-variants]', []);
      this.matrix = this.parseData('[data-recipe-matrix]', {});
      this.i18n = this.parseData('[data-selector-i18n]', {});
      this.customizer = this.querySelector('[data-customizer]');
      this.customSegments = [...this.querySelectorAll('[data-pot-segment]')];
      this.customOptions = [...this.querySelectorAll('[data-custom-option]')];
      this.customSliderList = this.querySelector('[data-custom-slider-list]');
      this.customSelectedIndex = 0;
      this.customDragState = null;
      this.maxCustomComponents = Math.max(1, Number(this.dataset.maxComponents) || 4);
      this.insightPlants = this.querySelector('[data-insight-plants]');
      this.insightProperties = this.querySelector('[data-insight-properties]');
      this.insightCopy = this.querySelector('[data-insight-copy]');
      this.advancedDetails = this.querySelector('[data-substrate-advanced]');
      this.initCustomizer();

      if (this.advancedDetails && window.location.hash === '#Profi-Konfigurator') this.advancedDetails.open = true;

      if (!this.nativeSelect || !this.variants.length) return;

      const queryVariantId = new URL(window.location.href).searchParams.get('variant');
      if (queryVariantId && this.variants.some((variant) => String(variant.id) === queryVariantId)) {
        this.nativeSelect.value = queryVariantId;
      }

      this.nativeSelect.addEventListener('change', () => {
        const variant = this.variantById(this.nativeSelect.value);
        this.updateVariant(variant, true);
      });

      if (this.profileChoices.length && this.volumeChoices.length) {
        this.profileChoices.forEach((choice) => choice.addEventListener('change', () => this.updateFromChoices()));
        this.volumeChoices.forEach((choice) => choice.addEventListener('change', () => this.updateFromChoices()));
        this.dataset.enhanced = 'true';
        if (this.nativeField) this.nativeField.hidden = true;
      }

      const initialVariant = this.variantById(this.nativeSelect.value) || this.variants.find((variant) => variant.available) || this.variants[0];
      this.updateVariant(initialVariant, false);
    }

    parseData(selector, fallback) {
      const node = this.querySelector(selector);
      if (!node?.textContent.trim()) return fallback;
      try {
        let parsed = JSON.parse(node.textContent);
        if (typeof parsed === 'string') parsed = JSON.parse(parsed);
        return parsed || fallback;
      } catch (error) {
        return fallback;
      }
    }

    t(key, fallback = '') {
      return this.i18n?.[key] || fallback;
    }

    formatText(key, values = {}, fallback = '') {
      let output = this.t(key, fallback);
      Object.entries(values).forEach(([name, value]) => {
        output = output.split(`[${name}]`).join(String(value));
      });
      return output;
    }

    tList(key, fallback = '') {
      return this.t(key, fallback).split('|').map((item) => item.trim()).filter(Boolean);
    }

    isGermanLocale() {
      return String(this.dataset.locale || '').toLowerCase().startsWith('de');
    }

    translateIngredient(name) {
      if (this.isGermanLocale()) return name;
      const normalized = String(name || '').trim().toLowerCase();
      const translations = {
        'kokosfasern': 'Coconut fibre',
        'kokosfaser': 'Coconut fibre',
        'pinienrinde': 'Pine bark',
        'perlite': 'Perlite',
        'bims': 'Pumice',
        'lavagranulat': 'Lava granules',
        'lava': 'Lava granules',
        'sphagnum-moos': 'Sphagnum moss',
        'sphagnum': 'Sphagnum moss',
        'wurmhumus': 'Worm castings',
        'pflanzenkohle': 'Biochar',
        'blähton': 'Expanded clay',
        'algenkalk': 'Algae lime',
        'mykorrhiza': 'Mycorrhiza',
        'aktivierter biokohle-kompost': 'Activated biochar compost',
        'zeolith': 'Zeolite',
        'vermiculit': 'Vermiculite',
        'vermiculite': 'Vermiculite',
        'tongranulat': 'Clay granules'
      };
      return translations[normalized] || name;
    }

    recipeForProfile(profile) {
      const canonicalProfiles = {
        'Herbs & Balcony': 'Kräuter & Balkon',
        'Cacti & Succulents': 'Kakteen & Sukkulenten',
        'Orchids': 'Orchideen',
        'Palms & Green Plants': 'Palmen & Grünpflanzen',
        'Seed Starting & Seedlings': 'Anzucht & Jungpflanzen'
      };
      return this.matrix?.recipes?.[profile] || this.matrix?.recipes?.[canonicalProfiles[profile]];
    }

    variantById(id) {
      return this.variants.find((variant) => String(variant.id) === String(id));
    }

    updateFromChoices() {
      const profile = this.profileChoices.find((choice) => choice.checked)?.value;
      const volume = this.volumeChoices.find((choice) => choice.checked)?.value;
      const variant = this.variants.find((item) => {
        return item.options?.[this.dataset.profileOption] === profile && item.options?.[this.dataset.volumeOption] === volume;
      });
      if (variant) this.updateVariant(variant, true);
    }

    updateVariant(variant, updateUrl) {
      if (!variant) return;

      this.nativeSelect.value = String(variant.id);
      const profile = variant.options?.[this.dataset.profileOption] || '';
      const volume = variant.options?.[this.dataset.volumeOption] || '';
      this.syncChoice(this.profileChoices, profile);
      this.syncChoice(this.volumeChoices, volume);

      const price = this.formatMoney(variant.price);
      this.querySelectorAll('[data-selected-price]').forEach((node) => { node.textContent = price; });

      const summary = this.querySelector('[data-selection-summary]');
      if (summary) summary.textContent = [profile, volume].filter(Boolean).join(' · ');

      const recipeSelection = this.querySelector('[data-recipe-selection]');
      if (recipeSelection) recipeSelection.textContent = [profile, volume].filter(Boolean).join(' · ');

      const availability = this.querySelector('[data-availability]');
      if (availability) {
        availability.dataset.state = variant.available ? 'available' : 'unavailable';
        availability.textContent = variant.available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
      }

      const submit = this.querySelector('[data-submit]');
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }

      this.setProperty('[data-property-profile]', profile);
      this.setProperty('[data-property-volume]', volume);
      const customSegments = this.activeCustomSegments();
      if (customSegments.length) this.renderRecipe(profile, volume);
      const recipeText = customSegments.length ? this.renderCustomRecipe(volume) : this.renderRecipe(profile, volume);
      this.updateInsights(profile, customSegments);
      this.setProperty('[data-property-recipe]', recipeText);
      this.setProperty('[data-property-version]', this.matrix?.version || this.querySelector('[data-recipe-version]')?.textContent.trim() || '');

      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }


    initCustomizer() {
      if (!this.customizer) return;
      this.customOptions.forEach((option) => {
        option.addEventListener('click', () => {
          const active = option.getAttribute('aria-pressed') === 'true';
          if (!active && this.activeCustomSegments().length >= this.maxCustomComponents) return;
          option.setAttribute('aria-pressed', active ? 'false' : 'true');
          if (!active) {
            const freeSegment = this.customSegments.find((segment) => segment.hidden);
            if (freeSegment) {
              freeSegment.hidden = false;
              freeSegment.dataset.name = option.dataset.name;
              freeSegment.dataset.share = '0';
              freeSegment.dataset.proMin = option.dataset.proMin || '0';
              freeSegment.dataset.proMax = option.dataset.proMax || '100';
              freeSegment.dataset.warning = option.dataset.warning || option.dataset.proMax || '100';
              freeSegment.dataset.aeration = option.dataset.aeration || '';
              freeSegment.dataset.drainage = option.dataset.drainage || '';
              freeSegment.dataset.waterRetention = option.dataset.waterRetention || '';
              freeSegment.dataset.structure = option.dataset.structure || '';
              freeSegment.dataset.nutrient = option.dataset.nutrient || '';
              freeSegment.dataset.technicalNote = option.dataset.technicalNote || '';
              freeSegment.dataset.order = String(this.nextCustomOrder());
              const preview = option.querySelector('img');
              freeSegment.dataset.image = preview?.currentSrc || preview?.src || '';
            }
          } else {
            const segment = this.customSegments.find((item) => item.dataset.name === option.dataset.name);
            if (segment) {
              segment.hidden = true;
              delete segment.dataset.name;
              delete segment.dataset.share;
              delete segment.dataset.proMin;
              delete segment.dataset.proMax;
              delete segment.dataset.warning;
              delete segment.dataset.aeration;
              delete segment.dataset.drainage;
              delete segment.dataset.waterRetention;
              delete segment.dataset.structure;
              delete segment.dataset.nutrient;
              delete segment.dataset.technicalNote;
              delete segment.dataset.order;
              delete segment.dataset.image;
              segment.style.removeProperty('background-image');
              segment.style.removeProperty('background-size');
              segment.style.removeProperty('background-position');
              segment.style.removeProperty('background-blend-mode');
              segment.classList.remove('is-selected');
            }
          }
          this.equalizeCustomSegments();
          this.refreshCustomRecipe();
        });
      });
      this.customSegments.forEach((segment) => {
        segment.addEventListener('click', () => {
          if (segment.hidden || segment.dataset.justDragged === 'true') return;
          this.customSelectedIndex = Number(segment.dataset.index);
          this.customSegments.forEach((item) => item.classList.toggle('is-selected', item === segment));
          const slider = this.customSliderList?.querySelector(`[data-custom-segment-slider="${segment.dataset.index}"]`);
          slider?.focus({ preventScroll: true });
        });
        segment.addEventListener('pointerdown', (event) => this.beginCustomDrag(event, segment));
        segment.addEventListener('pointermove', (event) => this.moveCustomDrag(event, segment));
        segment.addEventListener('pointerup', (event) => this.endCustomDrag(event, segment));
        segment.addEventListener('pointercancel', (event) => this.endCustomDrag(event, segment));
        segment.addEventListener('keydown', (event) => {
          if (segment.hidden || (event.key !== 'ArrowUp' && event.key !== 'ArrowDown')) return;
          event.preventDefault();
          this.moveCustomSegment(segment, event.key === 'ArrowUp' ? -1 : 1);
        });
      });
      this.syncCustomUI();
    }

    activeCustomSegments() {
      return (this.customSegments || [])
        .filter((segment) => !segment.hidden && segment.dataset.name)
        .sort((a, b) => (Number(a.dataset.order) || 0) - (Number(b.dataset.order) || 0));
    }

    nextCustomOrder() {
      return this.activeCustomSegments().reduce((max, segment) => Math.max(max, Number(segment.dataset.order) || 0), -1) + 1;
    }

    visualCustomSegments() {
      return this.activeCustomSegments().slice().sort((a, b) => {
        const aTop = a.getBoundingClientRect().top;
        const bTop = b.getBoundingClientRect().top;
        if (aTop !== bTop) return aTop - bTop;
        return (Number(b.dataset.order) || 0) - (Number(a.dataset.order) || 0);
      });
    }

    beginCustomDrag(event, segment) {
      if (segment.hidden || event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
      event.preventDefault();
      this.customSelectedIndex = Number(segment.dataset.index);
      this.customDragState = { pointerId: event.pointerId, segment, startY: event.clientY, moved: false };
      segment.classList.add('is-dragging');
      try { segment.setPointerCapture(event.pointerId); } catch {}
    }

    moveCustomDrag(event, segment) {
      const state = this.customDragState;
      if (!state || state.segment !== segment || state.pointerId !== event.pointerId) return;
      const delta = event.clientY - state.startY;
      if (Math.abs(delta) > 5) state.moved = true;
      if (!state.moved) return;
      event.preventDefault();
      segment.style.transform = `translateY(${delta}px) scale(1.015)`;
    }

    endCustomDrag(event, segment) {
      const state = this.customDragState;
      if (!state || state.segment !== segment || state.pointerId !== event.pointerId) return;
      const shouldCommit = state.moved && event.type !== 'pointercancel';
      if (shouldCommit) {
        event.preventDefault();
        this.reorderCustomSegments(segment, event.clientY);
        segment.dataset.justDragged = 'true';
        window.setTimeout(() => { delete segment.dataset.justDragged; }, 0);
      }
      segment.style.removeProperty('transform');
      segment.classList.remove('is-dragging');
      try { segment.releasePointerCapture(event.pointerId); } catch {}
      this.customDragState = null;
    }

    reorderCustomSegments(dragged, clientY) {
      const visual = this.visualCustomSegments();
      const shares = new Map(visual.map((segment) => [segment, segment.dataset.share]));
      const withoutDragged = visual.filter((segment) => segment !== dragged);
      let insertAt = withoutDragged.findIndex((segment) => {
        const rect = segment.getBoundingClientRect();
        return clientY < rect.top + rect.height / 2;
      });
      if (insertAt < 0) insertAt = withoutDragged.length;
      withoutDragged.splice(insertAt, 0, dragged);
      withoutDragged.forEach((segment, index) => {
        segment.dataset.order = String(withoutDragged.length - 1 - index);
      });
      shares.forEach((share, segment) => { segment.dataset.share = share; });
      this.updateCustomSegmentVisuals();
      this.renderCustomSliders();
      this.refreshCustomRecipe();
    }

    moveCustomSegment(segment, direction) {
      const visual = this.visualCustomSegments();
      const currentIndex = visual.indexOf(segment);
      const targetIndex = Math.max(0, Math.min(visual.length - 1, currentIndex + direction));
      if (currentIndex < 0 || targetIndex === currentIndex) return;
      visual.splice(currentIndex, 1);
      visual.splice(targetIndex, 0, segment);
      visual.forEach((item, index) => {
        item.dataset.order = String(visual.length - 1 - index);
      });
      this.updateCustomSegmentVisuals();
      this.renderCustomSliders();
      this.refreshCustomRecipe();
      segment.focus({ preventScroll: true });
    }

    equalizeCustomSegments() {
      const segments = this.activeCustomSegments();
      if (!segments.length) {
        this.customSelectedIndex = 0;
        this.syncCustomUI();
        return;
      }

      const minFor = (segment) => Math.max(0, Number(segment.dataset.proMin) || 0);
      const maxFor = (segment) => Math.min(100, Number(segment.dataset.proMax) || 100);
      let remaining = 100;

      segments.forEach((segment) => {
        const minimum = minFor(segment);
        segment.dataset.share = String(minimum);
        remaining -= minimum;
      });

      let guard = 0;
      while (remaining > 0 && guard < 1000) {
        const candidates = segments.filter((segment) => Number(segment.dataset.share) < maxFor(segment));
        if (!candidates.length) break;

        const fairShare = Math.max(1, Math.floor(remaining / candidates.length));
        for (const segment of candidates) {
          if (remaining <= 0) break;
          const current = Number(segment.dataset.share) || 0;
          const capacity = maxFor(segment) - current;
          const addition = Math.min(fairShare, capacity, remaining);
          segment.dataset.share = String(current + addition);
          remaining -= addition;
        }
        guard += 1;
      }

      if (remaining > 0) {
        const fallback = segments.find((segment) => Number(segment.dataset.share) < 100);
        if (fallback) fallback.dataset.share = String(Number(fallback.dataset.share) + remaining);
      }

      this.customSelectedIndex = Number(segments[0].dataset.index);
      this.syncCustomUI();
    }

    balanceCustomSegment(selected, rawValue) {
      const segments = this.activeCustomSegments();
      if (!selected || !segments.length) return;

      if (segments.length === 1) {
        selected.dataset.share = '100';
        this.updateCustomSegmentVisuals();
        this.updateCustomSliderValues();
        this.updateProFeedback();
        return;
      }

      const minFor = (segment) => Math.max(0, Number(segment.dataset.proMin) || 0);
      const maxFor = (segment) => Math.min(100, Number(segment.dataset.proMax) || 100);
      const others = segments.filter((segment) => segment !== selected);
      const othersMin = others.reduce((sum, segment) => sum + minFor(segment), 0);
      const othersMax = others.reduce((sum, segment) => sum + maxFor(segment), 0);
      const selectedMin = Math.max(minFor(selected), 100 - othersMax);
      const selectedMax = Math.min(maxFor(selected), 100 - othersMin);
      const lower = Math.min(selectedMin, selectedMax);
      const upper = Math.max(selectedMin, selectedMax);
      const requested = Math.max(lower, Math.min(upper, Number(rawValue) || lower));
      selected.dataset.share = String(Math.round(requested));

      const targetOtherTotal = 100 - Number(selected.dataset.share);
      const priorWeight = others.reduce((sum, segment) => sum + Math.max(1, Number(segment.dataset.share) || 0), 0);
      let assigned = 0;

      others.forEach((segment) => {
        const proportional = Math.round(targetOtherTotal * Math.max(1, Number(segment.dataset.share) || 0) / priorWeight);
        const share = Math.max(minFor(segment), Math.min(maxFor(segment), proportional));
        segment.dataset.share = String(share);
        assigned += share;
      });

      let delta = targetOtherTotal - assigned;
      let guard = 0;
      while (delta !== 0 && guard < 500) {
        const growing = delta > 0;
        const candidates = others
          .filter((segment) => growing
            ? Number(segment.dataset.share) < maxFor(segment)
            : Number(segment.dataset.share) > minFor(segment))
          .sort((a, b) => {
            const aCapacity = growing ? maxFor(a) - Number(a.dataset.share) : Number(a.dataset.share) - minFor(a);
            const bCapacity = growing ? maxFor(b) - Number(b.dataset.share) : Number(b.dataset.share) - minFor(b);
            return bCapacity - aCapacity;
          });
        if (!candidates.length) break;
        const candidate = candidates[guard % candidates.length];
        candidate.dataset.share = String(Number(candidate.dataset.share) + (growing ? 1 : -1));
        delta += growing ? -1 : 1;
        guard += 1;
      }

      this.updateCustomSegmentVisuals();
      this.updateCustomSliderValues();
      this.updateProFeedback();
    }

    materialTexture(name = '') {
      const label = String(name).toLowerCase();
      // Material-specific, repeatable grain textures. No product image URLs in the pot.
      const materials = [
        { match: /perlit/, color: '#e9e7df', grain: 8 },
        { match: /bims|pumice/, color: '#b7b2a4', grain: 14 },
        { match: /lava/, color: '#544a43', grain: 12 },
        { match: /seramis|tonbruch|blähton|blaehton/, color: '#a75e42', grain: 13 },
        { match: /pinien|rinde|bark/, color: '#745039', grain: 19 },
        { match: /sphagnum|moos|moss/, color: '#8a8351', grain: 11 },
        { match: /kokos|coco/, color: '#896a50', grain: 10 },
        { match: /wurmhumus|kompost|humus|erde/, color: '#433b31', grain: 6 },
        { match: /kohle|biochar/, color: '#383735', grain: 8 },
        { match: /zeolith/, color: '#a1a79b', grain: 11 },
        { match: /sand|quarz/, color: '#c8b999', grain: 5 }
      ];
      const match = materials.find((entry) => entry.match.test(label)) || { color: '#958570', grain: 10 };
      const grain = match.grain;
      return {
        color: match.color,
        size: `${grain}px ${grain}px, ${Math.round(grain * 1.6)}px ${Math.round(grain * 1.6)}px, auto`,
        pattern: 'radial-gradient(ellipse at 25% 28%, rgba(255,255,255,.48) 0 16%, transparent 20%), radial-gradient(ellipse at 68% 72%, rgba(0,0,0,.28) 0 21%, transparent 24%), linear-gradient(135deg, rgba(255,255,255,.12), rgba(0,0,0,.12))'
      };
    }

    updateCustomSegmentVisuals() {
      this.customSegments.forEach((segment) => {
        const share = Number(segment.dataset.share) || 0;
        segment.style.height = share ? `${share}%` : '';
        segment.style.order = String(Number(segment.dataset.order) || 0);
        segment.textContent = share ? `${this.translateIngredient(segment.dataset.name).split(/\s+[–—-]\s+/)[0].trim()} · ${share}%` : '';
        segment.setAttribute('aria-label', share ? this.formatText('segment_percent', { name: segment.dataset.name, share }) : this.t('free_segment'));
        // The pot visualises loose substrate, never packaged product photography.
        const material = this.materialTexture(segment.dataset.name);
        segment.style.backgroundColor = material.color;
        segment.style.backgroundImage = material.pattern;
        segment.style.backgroundSize = material.size;
        segment.style.backgroundPosition = 'center';
        segment.style.removeProperty('background-blend-mode');
      });
    }

    renderCustomSliders() {
      if (!this.customSliderList) return;
      const segments = this.activeCustomSegments().slice().sort((a, b) => (Number(b.dataset.order) || 0) - (Number(a.dataset.order) || 0));
      this.customSliderList.replaceChildren();

      segments.forEach((segment) => {
        const row = document.createElement('label');
        row.className = 'leafer-substrate__mix-slider';

        const thumb = document.createElement('span');
        thumb.className = 'leafer-substrate__mix-slider-thumb';
        thumb.setAttribute('aria-hidden', 'true');
        const material = this.materialTexture(segment.dataset.name);
        thumb.style.backgroundColor = material.color;
        thumb.style.backgroundImage = material.pattern;
        thumb.style.backgroundSize = material.size;

        const name = document.createElement('strong');
        name.className = 'leafer-substrate__mix-slider-name';
        name.textContent = this.translateIngredient(segment.dataset.name);

        const output = document.createElement('output');
        output.dataset.customSegmentOutput = segment.dataset.index;
        output.textContent = `${segment.dataset.share || 0} %`;

        const range = document.createElement('input');
        range.type = 'range';
        range.step = '1';
        range.min = String(Math.max(0, Number(segment.dataset.proMin) || 0));
        range.max = String(Math.min(100, Number(segment.dataset.proMax) || 100));
        range.value = String(Number(segment.dataset.share) || 0);
        range.dataset.customSegmentSlider = segment.dataset.index;
        range.setAttribute('aria-label', segment.dataset.name);
        range.addEventListener('input', () => {
          this.customSelectedIndex = Number(segment.dataset.index);
          this.customSegments.forEach((item) => item.classList.toggle('is-selected', item === segment));
          this.balanceCustomSegment(segment, range.value);
          this.refreshCustomRecipe();
        });

        row.append(thumb, name, output, range);
        this.customSliderList.append(row);
      });
    }

    updateCustomSliderValues() {
      if (!this.customSliderList) return;
      this.activeCustomSegments().forEach((segment) => {
        const slider = this.customSliderList.querySelector(`[data-custom-segment-slider="${segment.dataset.index}"]`);
        const output = this.customSliderList.querySelector(`[data-custom-segment-output="${segment.dataset.index}"]`);
        if (slider) slider.value = String(Number(segment.dataset.share) || 0);
        if (output) output.textContent = `${segment.dataset.share || 0} %`;
      });
    }

    syncCustomUI() {
      const segments = this.activeCustomSegments();
      const count = this.querySelector('[data-customizer-count]');
      const hint = this.querySelector('[data-customizer-hint]');
      const atLimit = segments.length >= this.maxCustomComponents;
      if (count) count.textContent = String(segments.length);
      if (hint) {
        hint.textContent = !segments.length
          ? this.t('hint_empty')
          : atLimit
            ? this.t('hint_limit')
            : this.t('hint_adjust');
      }
      this.customOptions.forEach((option) => {
        const active = segments.some((segment) => segment.dataset.name === option.dataset.name);
        const blocked = atLimit && !active;
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
        option.disabled = blocked;
        option.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      });
      this.updateCustomSegmentVisuals();
      this.renderCustomSliders();
      this.updateProFeedback();
    }

    updateProFeedback() {
      const feedback = this.querySelector('[data-pro-feedback]');
      if (!feedback) return;
      const segments = this.activeCustomSegments();
      if (!segments.length) { feedback.hidden = true; feedback.replaceChildren(); return; }
      const warnings = [];
      const metrics = { aeration: 0, drainage: 0, water: 0, structure: 0, nutrient: 0 };
      let metricWeight = 0;
      segments.forEach((segment) => {
        const share = Number(segment.dataset.share) || 0;
        const warning = Number(segment.dataset.warning) || 100;
        const max = Number(segment.dataset.proMax) || 100;
        if (share > max) warnings.push(this.formatText('warning_max', { name: segment.dataset.name, share, max }));
        else if (share > warning) warnings.push(this.formatText('warning_threshold', { name: segment.dataset.name, share, warning }));
        ['aeration','drainage','structure','nutrient'].forEach((key) => {
          const value = Number(segment.dataset[key]);
          if (Number.isFinite(value) && value > 0) metrics[key] += value * share;
        });
        const water = Number(segment.dataset.waterRetention);
        if (Number.isFinite(water) && water > 0) metrics.water += water * share;
        metricWeight += share;
      });
      feedback.replaceChildren();
      const summary = document.createElement('p');
      summary.className = 'leafer-substrate__pro-summary';
      summary.textContent = warnings.length ? this.t('feedback_warning') : this.t('feedback_ok');
      feedback.append(summary);
      if (warnings.length) {
        const list = document.createElement('ul');
        warnings.forEach((warning) => { const li = document.createElement('li'); li.textContent = warning; list.append(li); });
        feedback.append(list);
      }
      if (metricWeight > 0) {
        const grid = document.createElement('div');
        grid.className = 'leafer-substrate__pro-metrics';
        [[this.t('metric_aeration'),'aeration'],[this.t('metric_drainage'),'drainage'],[this.t('metric_water'),'water'],[this.t('metric_structure'),'structure'],[this.t('metric_nutrient'),'nutrient']].forEach(([label,key]) => {
          if (!metrics[key]) return;
          const item = document.createElement('span');
          item.textContent = `${label} ${Math.round(metrics[key] / metricWeight)}/10`;
          grid.append(item);
        });
        feedback.append(grid);
      }
      const selected = segments.find((segment) => Number(segment.dataset.index) === this.customSelectedIndex) || segments[0];
      if (this.isGermanLocale() && selected?.dataset.technicalNote) { const note = document.createElement('small'); note.textContent = selected.dataset.technicalNote; feedback.append(note); }
      feedback.hidden = false;
    }

    renderCustomRecipe(volume) {
      const segments = this.activeCustomSegments();
      const list = this.querySelector('[data-recipe-list]');
      const empty = this.querySelector('[data-recipe-empty]');
      const sizeKey = String(volume).match(/[\d.,]+/)?.[0]?.replace(',', '.');
      const litresTotal = Number(sizeKey) || 0;
      if (!list || !segments.length) return '';
      list.replaceChildren();
      if (empty) empty.hidden = true;
      const fragment = document.createDocumentFragment();
      const recipeParts = [];
      let total = 0;
      segments.forEach((segment) => {
        const share = Number(segment.dataset.share) || 0;
        const litres = litresTotal * share / 100;
        total += share;
        const row = document.createElement('div');
        row.className = 'leafer-substrate__recipe-row';
        const head = document.createElement('div');
        head.className = 'leafer-substrate__recipe-row-head';
        const name = document.createElement('strong');
        name.textContent = segment.dataset.name;
        const values = document.createElement('span');
        values.className = 'leafer-substrate__recipe-values';
        values.append(
          document.createTextNode(`${this.formatNumber(share)} %`),
          document.createTextNode(' · '),
          document.createTextNode(`${this.formatNumber(litres)} L`)
        );
        head.append(name, values);
        const bar = document.createElement('div');
        bar.className = 'leafer-substrate__recipe-bar';
        const fill = document.createElement('span');
        fill.style.setProperty('--share', `${share}%`);
        bar.append(fill);
        row.append(head, bar);
        fragment.append(row);
        recipeParts.push(`${this.translateIngredient(segment.dataset.name)} ${this.formatNumber(share)} % (${this.formatNumber(litres)} L)`);
      });
      list.append(fragment);
      const totalNode = this.querySelector('[data-recipe-total]');
      if (totalNode) totalNode.textContent = `${this.formatNumber(total)} % · ${volume}`;
      const basisNode = this.querySelector('[data-recipe-basis]');
      if (basisNode) basisNode.textContent = this.t('custom_basis');
      const versionNode = this.querySelector('[data-recipe-version]');
      if (versionNode) versionNode.textContent = this.t('custom_version');
      const totalLabel = this.querySelector('[data-customizer-total]');
      if (totalLabel) totalLabel.textContent = `${this.formatNumber(total)} % · ${this.formatNumber(litresTotal)} L`;
      const notesList = this.querySelector('[data-recipe-notes]');
      if (notesList) {
        notesList.replaceChildren();
        notesList.hidden = true;
      }
      return recipeParts.join(' · ');
    }

    refreshCustomRecipe() {
      const variant = this.variantById(this.nativeSelect?.value);
      if (!variant) return;
      const volume = variant.options?.[this.dataset.volumeOption] || '';
      if (this.activeCustomSegments().length) {
        const profile = variant.options?.[this.dataset.profileOption] || '';
        const recipeText = this.renderCustomRecipe(volume);
        this.updateInsights(profile, this.activeCustomSegments());
        this.setProperty('[data-property-recipe]', recipeText);
        this.setProperty('[data-property-version]', this.t('custom_version'));
      } else {
        const profile = variant.options?.[this.dataset.profileOption] || '';
        this.renderRecipe(profile, volume);
        this.updateInsights(profile, []);
        this.setProperty('[data-property-recipe]', '');
        this.setProperty('[data-property-version]', this.matrix?.version || '');
      }
    }


    updateInsights(profile, customSegments) {
      if (!this.insightPlants || !this.insightProperties) return;
      const normalized = String(profile || '').toLowerCase();
      let rule = {
        plants: this.tList('insight_default_plants'),
        properties: this.tList('insight_default_properties'),
        copy: this.t('insight_default_copy')
      };
      if (normalized.includes('aroid') || normalized.includes('tropical') || normalized.includes('luftig') || normalized.includes('airy')) {
        rule = { plants: this.tList('insight_aroid_plants'), properties: this.tList('insight_aroid_properties'), copy: this.t('insight_aroid_copy') };
      } else if (normalized.includes('kräuter') || normalized.includes('balkon') || normalized.includes('ausgewogen') || normalized.includes('herb') || normalized.includes('balcony') || normalized.includes('balanced')) {
        rule = { plants: this.tList('insight_herb_plants'), properties: this.tList('insight_herb_properties'), copy: this.t('insight_herb_copy') };
      } else if (normalized.includes('kakt') || normalized.includes('sukkulent') || normalized.includes('mineral') || normalized.includes('cactus') || normalized.includes('succulent')) {
        rule = { plants: this.tList('insight_cactus_plants'), properties: this.tList('insight_cactus_properties'), copy: this.t('insight_cactus_copy') };
      } else if (normalized.includes('orchid') || normalized.includes('orchidee') || normalized.includes('rinden') || normalized.includes('bark')) {
        rule = { plants: this.tList('insight_orchid_plants'), properties: this.tList('insight_orchid_properties'), copy: this.t('insight_orchid_copy') };
      } else if (normalized.includes('palm') || normalized.includes('palmen') || normalized.includes('struktur') || normalized.includes('structure')) {
        rule = { plants: this.tList('insight_palm_plants'), properties: this.tList('insight_palm_properties'), copy: this.t('insight_palm_copy') };
      } else if (normalized.includes('anzucht') || normalized.includes('jung') || normalized.includes('fein') || normalized.includes('propagation') || normalized.includes('young') || normalized.includes('seed')) {
        rule = { plants: this.tList('insight_seed_plants'), properties: this.tList('insight_seed_properties'), copy: this.t('insight_seed_copy') };
      }

      const names = customSegments.length ? customSegments.map((segment) => segment.dataset.name) : Object.keys(this.recipeForProfile(profile)?.percent || {});
      const additions = [];
      names.forEach((name) => {
        const item = String(name).toLowerCase();
        if (item.includes('perlit') || item.includes('bims') || item.includes('pumice') || item.includes('lava') || item.includes('blähton') || item.includes('expanded clay')) additions.push(this.t('addition_drainage'));
        if (item.includes('kokos') || item.includes('coconut') || item.includes('sphagnum') || item.includes('moos') || item.includes('moss')) additions.push(this.t('addition_moisture'));
        if (item.includes('rinde') || item.includes('bark')) additions.push(this.t('addition_bark'));
        if (item.includes('wurmhumus') || item.includes('worm') || item.includes('kompost') || item.includes('compost')) additions.push(this.t('addition_nutrient'));
        if (item.includes('algenkalk') || item.includes('algae lime')) additions.push(this.t('addition_ph'));
        if (item.includes('mykorrhiza') || item.includes('mycorrhiza')) additions.push(this.t('addition_root'));
      });
      const properties = [...new Set([...rule.properties, ...additions])];
      this.insightPlants.replaceChildren();
      rule.plants.forEach((plant) => {
        const chip = document.createElement('span');
        chip.textContent = plant;
        this.insightPlants.append(chip);
      });
      this.insightProperties.replaceChildren();
      properties.forEach((property) => {
        const item = document.createElement('li');
        item.textContent = property;
        this.insightProperties.append(item);
      });
      if (this.insightCopy) this.insightCopy.textContent = rule.copy;
    }

    syncChoice(choices, value) {
      choices.forEach((choice) => { choice.checked = choice.value === value; });
    }

    setProperty(selector, value) {
      const input = this.querySelector(selector);
      if (!input) return;
      input.value = value || '';
      input.disabled = !value;
    }

    renderRecipe(profile, volume) {
      const recipe = this.recipeForProfile(profile);
      const sizeKey = String(volume).match(/[\d.,]+/)?.[0]?.replace(',', '.');
      const percentages = recipe?.percent || {};
      const sizes = recipe?.sizes_l?.[sizeKey] || recipe?.sizes_l?.[String(Number(sizeKey))] || {};
      const entries = Object.entries(percentages);
      const lists = [...this.querySelectorAll('[data-recipe-list], [data-base-recipe-list]')];
      const list = lists[0];
      const empty = this.querySelector('[data-recipe-empty]');
      const notesList = this.querySelector('[data-recipe-notes]');

      if (!lists.length || !list) return '';
      lists.forEach((targetList) => targetList.replaceChildren());

      if (!entries.length) {
        if (empty) empty.hidden = false;
        if (notesList) notesList.hidden = true;
        return '';
      }

      if (empty) empty.hidden = true;
      const fragment = document.createDocumentFragment();
      let total = 0;
      const recipeParts = [];

      entries.forEach(([ingredient, rawShare]) => {
        const share = Number(rawShare) || 0;
        const litres = sizes?.[ingredient];
        total += share;

        const row = document.createElement('div');
        row.className = 'leafer-substrate__recipe-row';

        const head = document.createElement('div');
        head.className = 'leafer-substrate__recipe-row-head';

        const name = document.createElement('strong');
        name.textContent = this.translateIngredient(ingredient);

        const values = document.createElement('span');
        values.className = 'leafer-substrate__recipe-values';

        const percentage = document.createElement('span');
        percentage.textContent = `${this.formatNumber(share)} %`;
        values.append(percentage);

        if (litres !== undefined && litres !== null) {
          const amount = document.createElement('span');
          amount.textContent = `${this.formatNumber(litres)} L`;
          values.append(amount);
          recipeParts.push(`${this.translateIngredient(ingredient)} ${this.formatNumber(share)} % (${this.formatNumber(litres)} L)`);
        } else {
          recipeParts.push(`${this.translateIngredient(ingredient)} ${this.formatNumber(share)} %`);
        }

        head.append(name, values);

        const bar = document.createElement('div');
        bar.className = 'leafer-substrate__recipe-bar';
        const fill = document.createElement('span');
        fill.style.setProperty('--share', `${Math.max(0, Math.min(100, share))}%`);
        bar.append(fill);

        row.append(head, bar);
        fragment.append(row);
      });

      lists.forEach((targetList) => targetList.append(fragment.cloneNode(true)));
      const baseSelection = this.querySelector('[data-base-recipe-selection]');
      if (baseSelection) baseSelection.textContent = [profile, volume].filter(Boolean).join(' · ');
      const totalNode = this.querySelector('[data-recipe-total]');
      if (totalNode) totalNode.textContent = `${this.formatNumber(total)} % · ${volume}`;
      const basisNode = this.querySelector('[data-recipe-basis]');
      if (basisNode) basisNode.textContent = this.isGermanLocale() && this.matrix?.basis ? this.matrix.basis : this.t('volume_shares', 'Volume shares');
      const versionNode = this.querySelector('[data-recipe-version]');
      if (versionNode && this.matrix?.version) versionNode.textContent = this.matrix.version;

      this.renderNotes(percentages, notesList);
      return recipeParts.join(' · ');
    }

    renderNotes(percentages, notesList) {
      if (!notesList) return;
      notesList.replaceChildren();
      if (!this.isGermanLocale()) { notesList.hidden = true; return; }
      const notes = Object.entries(this.matrix?.notes || {}).filter(([ingredient]) => Object.prototype.hasOwnProperty.call(percentages, ingredient));
      if (!notes.length) {
        notesList.hidden = true;
        return;
      }

      const fragment = document.createDocumentFragment();
      notes.forEach(([ingredient, note]) => {
        const item = document.createElement('li');
        const label = document.createElement('strong');
        label.textContent = `${ingredient}: `;
        item.append(label, document.createTextNode(note));
        fragment.append(item);
      });
      notesList.append(fragment);
      notesList.hidden = false;
    }

    formatMoney(cents) {
      const amount = Number(cents) / 100;
      try {
        return new Intl.NumberFormat(this.dataset.locale || 'de-DE', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR'
        }).format(amount);
      } catch (error) {
        return `${amount.toFixed(2)} ${this.dataset.currency || 'EUR'}`;
      }
    }

    formatNumber(value) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || 'de-DE', {
          maximumFractionDigits: 2
        }).format(Number(value));
      } catch (error) {
        return String(value);
      }
    }
  }

  if (!customElements.get('leafer-substrate-selector')) {
    customElements.define('leafer-substrate-selector', LeaferSubstrateSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const tools = document.querySelector('[data-article-tools]');
    if (!tools) return;
    const article = tools.closest('.main-article');
    const body = article?.querySelector('[data-article-body]');
    const tocList = tools.querySelector('[data-article-toc-list]');
    const progress = tools.querySelector('[data-article-progress]');
    const focusButton = tools.querySelector('[data-article-focus]');
    if (!article || !body || !tocList || !progress || !focusButton) return;
    const progressLabel = tools.dataset.progressLabel || 'read';
    const focusOpen = tools.dataset.focusOpen || 'Open focus mode';
    const focusClose = tools.dataset.focusClose || 'Close focus mode';

    const headings = [...body.querySelectorAll('h2')];
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `ArticleSection-${index + 1}-${heading.textContent.trim().toLowerCase().replace(/[^a-z0-9äöüß]+/gi, '-').replace(/^-|-$/g, '')}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', () => {
        heading.focus({preventScroll: true});
      });
      item.append(link);
      tocList.append(item);
    });
    if (!headings.length) tools.querySelector('[data-article-toc]').hidden = true;

    const updateProgress = () => {
      const start = body.getBoundingClientRect().top + window.scrollY - window.innerHeight * .35;
      const end = body.getBoundingClientRect().bottom + window.scrollY - window.innerHeight * .65;
      const value = end <= start ? 100 : Math.min(100, Math.max(0, ((window.scrollY - start) / (end - start)) * 100));
      progress.textContent = `${Math.round(value)} % ${progressLabel}`;
      const visible = headings.reduce((current, heading) => {
        if (heading.getBoundingClientRect().top <= window.innerHeight * .3) return heading;
        return current;
      }, headings[0]);
      headings.forEach((heading) => {
        const link = tocList.querySelector(`a[href="#${heading.id}"]`);
        if (link) link.setAttribute('aria-current', heading === visible ? 'true' : 'false');
      });
    };

    focusButton.addEventListener('click', () => {
      const active = article.classList.toggle('main-article--focus');
      focusButton.setAttribute('aria-pressed', active ? 'true' : 'false');
      focusButton.textContent = active ? focusClose : focusOpen;
    });
    window.addEventListener('scroll', updateProgress, {passive: true});
    window.addEventListener('resize', updateProgress);
    updateProgress();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.requestSubmit());
  });

  document.querySelectorAll('.main-collection').forEach((collectionSection) => {
    const filters = collectionSection.querySelector('.main-collection__filters');
    if (!filters) return;
    const context = collectionSection.querySelector('[data-filter-context]');
    const contextIcon = context?.querySelector('[data-filter-context-icon]');
    const contextLabel = context?.querySelector('[data-filter-context-label]');
    const contextCount = context?.querySelector('[data-filter-context-count]');

    const syncFilter = (button) => {
      const selected = button.dataset.productFilter;
      const cards = [...collectionSection.querySelectorAll('[data-product-type]')];
      cards.forEach((card) => {
        card.hidden = selected !== 'all' && card.dataset.productType !== selected;
      });
      const visible = cards.filter((card) => !card.hidden).length;
      if (contextLabel) contextLabel.textContent = button.dataset.filterLabel || button.textContent.trim();
      if (contextCount) contextCount.textContent = String(visible);
      const sourceIcon = button.querySelector('.main-collection__filter-icon');
      if (contextIcon && sourceIcon) contextIcon.innerHTML = sourceIcon.innerHTML;
    };

    filters.addEventListener('click', (event) => {
      const button = event.target.closest('[data-product-filter]');
      if (!button) return;
      filters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      syncFilter(button);
    });

    const initial = filters.querySelector('[aria-pressed="true"]');
    if (initial) syncFilter(initial);
  });


  class InterieurSolutionsConfigurator extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
  
          this.form = this.querySelector('[data-config-form]');
          this.cards = [...this.querySelectorAll('[data-solution-card]')];
          this.profileTitle = this.querySelector('[data-profile-title]');
          this.profileCopy = this.querySelector('[data-profile-copy]');
          this.profileChips = this.querySelector('[data-profile-chips]');
          this.resultCount = this.querySelector('[data-result-count]');
          this.budgetNote = this.querySelector('[data-budget-note]');
          this.results = this.querySelector('[data-recommendations]');
  
          this.form?.addEventListener('input', () => this.update());
          this.querySelector('[data-reset]')?.addEventListener('click', () => this.reset());
  
          this.update();
        }
  
        value(name) {
          return this.form?.querySelector(`input[name="${name}"]:checked`)?.value || '';
        }
  
        label(name) {
          return this.form?.querySelector(`input[name="${name}"]:checked`)?.closest('label')?.querySelector('[data-option-label]')?.textContent?.trim() || '';
        }
  
        includes(text, terms) {
          return terms.some((term) => text.includes(term));
        }
  
        score(card, state) {
          const text = (card.dataset.search || '').toLocaleLowerCase('de-DE');
          const watts = Number(card.dataset.watts || 0);
          let score = 0;
  
          const projectTerms = {
            single: ['e27', 'par30', 'par38', 'teleskop', 'willow', 'vita', 'pflanzenlampe', 'pflanzenleuchte'],
            shelf: ['regal', 'grove', 'aurora', 'bar', 'tube', 'cx91', 'cx83'],
            pendant: ['pendel', 'pendant', 'wand', 'luna', 'aspect', 'stello'],
            station: ['pflanzenregal', 'gewächshaus', 'station', 'growzelt', 'vivosun', 'barrina', 'cx91', 'cx83'],
            habitat: ['terrarium', 'aquascap', 'wasserpflanz', 'daytime', 'sera', 'repmac']
          };
          if (this.includes(text, projectTerms[state.project] || [])) score += state.project === 'habitat' ? 8 : 6;
  
          const roomTerms = {
            living: ['soltech', 'mother', 'premium', 'wohn', 'willow', 'aspect', 'vita', 'grove'],
            office: ['mother', 'soltech', 'regal', 'stand', 'plantspectrum', 'grove'],
            kitchen: ['e27', 'bloom', '7w', '10w', '15w', 'kräuter', 'teleskop'],
            plantroom: ['sansi', 'barrina', 'vivosun', '60w', 'grow', 'station', 'gewächshaus']
          };
          if (this.includes(text, roomTerms[state.room] || [])) score += 4;
  
          const mountTerms = {
            e27: ['e27', 'par30', 'par38', 'bulb', 'leuchtmittel'],
            shelf: ['regal', 'grove', 'aurora', 'bar', 'tube'],
            pendant: ['pendel', 'pendant', 'wand', 'luna', 'aspect'],
            floor: ['stand', 'standfuß', 'floor', 'willow', 'stello', 'alta', 'teleskop'],
            system: ['station', 'gewächshaus', 'terrarium', 'zelt', 'regal']
          };
          if (state.mount !== 'open' && this.includes(text, mountTerms[state.mount] || [])) score += 5;
  
          if (state.light === 'supplement') {
            if (watts > 0 && watts <= 15) score += 4;
            if (this.includes(text, ['7w', '10w', '15w', 'e27', 'teleskop'])) score += 2;
          }
          if (state.light === 'balanced') {
            if (watts >= 10 && watts <= 35) score += 4;
            if (this.includes(text, ['20w', '24w', '25w', '32'])) score += 2;
          }
          if (state.light === 'intensive') {
            if (watts >= 25) score += 5;
            if (this.includes(text, ['36w', '60w', 'station', 'gewächshaus', 'plantspectrum32'])) score += 3;
          }
  
          if (state.project === 'habitat' && this.includes(text, ['terrarium', 'aquascap', 'wasserpflanz'])) score += 4;
          if (state.project === 'station' && this.includes(text, ['regal', 'station', 'gewächshaus'])) score += 4;
          if (state.room === 'living' && this.includes(text, ['growzelt', 'vivosun'])) score -= 4;
  
          return score;
        }
  
        update() {
          if (!this.form || !this.cards.length) return;
  
          const state = {
            room: this.value('room'),
            project: this.value('project'),
            mount: this.value('mount'),
            light: this.value('light'),
            budget: this.value('budget')
          };
          const budget = state.budget === 'open' ? Infinity : Number(state.budget || 150);
  
          const ranked = this.cards
            .map((card) => ({
              card,
              score: this.score(card, state),
              price: Number(card.dataset.price || 0)
            }))
            .sort((a, b) => b.score - a.score || a.price - b.price);
  
          let eligible = ranked.filter((item) => item.price <= budget && item.score > 0);
          let relaxed = false;
  
          if (eligible.length === 0) {
            eligible = ranked.filter((item) => item.score > 0);
            relaxed = true;
          }
          if (eligible.length === 0) eligible = ranked;
  
          const top = eligible.slice(0, 4);
          const selected = new Set(top.map((item) => item.card));
  
          this.cards.forEach((card) => {
            card.hidden = !selected.has(card);
          });
          top.forEach((item) => this.results?.append(item.card));
  
          const projectLabel = this.label('project');
          const roomLabel = this.label('room');
          if (this.profileTitle) this.profileTitle.textContent = [projectLabel, roomLabel].filter(Boolean).join(' · ');
          if (this.profileCopy) this.profileCopy.textContent = this.dataset.profileCopy || '';
  
          if (this.profileChips) {
            this.profileChips.replaceChildren();
            ['mount', 'light', 'budget'].forEach((name) => {
              const text = this.label(name);
              if (!text) return;
              const chip = document.createElement('span');
              chip.textContent = text;
              this.profileChips.append(chip);
            });
          }
  
          if (this.resultCount) {
            this.resultCount.textContent = top.length === 1
              ? (this.dataset.resultOne || '1')
              : `${top.length} ${this.dataset.resultMany || ''}`.trim();
          }
  
          if (this.budgetNote) {
            this.budgetNote.hidden = !relaxed;
            this.budgetNote.textContent = relaxed ? (this.dataset.budgetRelaxed || '') : '';
          }
        }
  
        reset() {
          if (!this.form) return;
          this.form.reset();
          this.update();
        }
      }
  
      if (!customElements.get('interieur-solutions-configurator')) {
        customElements.define('interieur-solutions-configurator', InterieurSolutionsConfigurator);
      }

  class InterieurRoomBuilder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      if (!window.matchMedia('(min-width: 1100px)').matches) return;
      this.dataset.ready = 'true';
      this.canvas = this.querySelector('[data-room-canvas]');
      if (!this.canvas) return;
      this.ctx = this.canvas.getContext('2d');
      this.room = {
        width: Number(this.querySelector('[data-room-width]')?.value || 4.2),
        depth: Number(this.querySelector('[data-room-depth]')?.value || 3.2),
        height: Number(this.querySelector('[data-room-height]')?.value || 2.5)
      };
      this.camera = -35;
      this.objects = [];
      this.selectedId = null;
      this.drag = null;
      this.objectId = 0;
      this.productImages = new Map();
      this.currency = this.dataset.currency || 'EUR';
      this.locale = document.documentElement.lang || 'de-DE';

      this.bind();
      this.restore();
      if (!this.objects.length) {
        this.addPrimitive('plant', -0.75, 0.2);
        this.addPrimitive('plant', 0.55, 0.55);
      }
      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this.canvas);
      this.resize();
      this.updateSummary();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    bind() {
      ['width', 'depth', 'height'].forEach((key) => {
        this.querySelector(`[data-room-${key}]`)?.addEventListener('input', (event) => {
          const limits = key === 'height' ? [2, 5] : [2, 12];
          this.room[key] = this.clamp(Number(event.target.value || limits[0]), limits[0], limits[1]);
          this.clampObjects();
          this.save();
          this.draw();
          this.updateSummary();
        });
      });

      this.querySelectorAll('[data-add-primitive]').forEach((button) => {
        button.addEventListener('click', () => this.addPrimitive(button.dataset.addPrimitive));
      });
      this.querySelector('[data-add-product]')?.addEventListener('click', () => this.addProduct());
      this.querySelectorAll('[data-camera]').forEach((button) => {
        button.addEventListener('click', () => {
          this.camera += Number(button.dataset.camera || 0);
          this.draw();
          this.save();
        });
      });
      this.querySelectorAll('[data-object-rotate]').forEach((button) => {
        button.addEventListener('click', () => this.rotateSelected(Number(button.dataset.objectRotate || 0)));
      });
      this.querySelector('[data-delete]')?.addEventListener('click', () => this.deleteSelected());
      this.querySelector('[data-duplicate]')?.addEventListener('click', () => this.duplicateSelected());
      this.querySelector('[data-builder-reset]')?.addEventListener('click', () => this.reset());
      this.querySelector('[data-add-setup]')?.addEventListener('click', () => this.addSetupToCart());

      this.canvas.addEventListener('pointerdown', (event) => this.pointerDown(event));
      this.canvas.addEventListener('pointermove', (event) => this.pointerMove(event));
      this.canvas.addEventListener('pointerup', () => this.pointerUp());
      this.canvas.addEventListener('pointercancel', () => this.pointerUp());
    }

    resize() {
      const rect = this.canvas.getBoundingClientRect();
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.max(1, Math.round(rect.width * ratio));
      const height = Math.max(1, Math.round(rect.height * ratio));
      if (this.canvas.width !== width || this.canvas.height !== height) {
        this.canvas.width = width;
        this.canvas.height = height;
      }
      this.draw();
    }

    addPrimitive(kind, x = 0, z = 0) {
      const presets = {
        plant: {title: 'Plant', width: .52, depth: .52, height: 1.05, color: '#55784e'},
        shelf: {title: 'Shelf', width: 1.2, depth: .38, height: 1.8, color: '#8a7257'},
        window: {title: 'Window', width: 1.4, depth: .12, height: 1.25, color: '#b8d5da'}
      };
      const preset = presets[kind];
      if (!preset) return;
      const obj = {
        id: ++this.objectId,
        kind,
        title: this.querySelector(`[data-add-primitive="${kind}"]`)?.textContent?.trim() || preset.title,
        x,
        z,
        rotation: 0,
        width: preset.width,
        depth: preset.depth,
        height: preset.height,
        color: preset.color,
        variantId: null,
        price: 0,
        watts: 0,
        url: ''
      };
      this.objects.push(obj);
      this.selectedId = obj.id;
      this.clampObject(obj);
      this.save();
      this.draw();
      this.updateSummary();
    }

    addProduct() {
      const select = this.querySelector('[data-builder-product-select]');
      const option = select?.selectedOptions?.[0];
      if (!option?.value) return;
      const search = (option.dataset.search || '').toLowerCase();
      const kind = this.productKind(search);
      const preset = this.productPreset(kind);
      const obj = {
        id: ++this.objectId,
        kind,
        title: option.dataset.title || option.textContent.trim(),
        x: 0,
        z: 0,
        rotation: 0,
        width: preset.width,
        depth: preset.depth,
        height: preset.height,
        color: preset.color,
        variantId: option.value,
        price: Number(option.dataset.price || 0),
        watts: Number(option.dataset.watts || 0),
        url: option.dataset.url || '',
        image: option.dataset.image || ''
      };
      this.objects.push(obj);
      this.selectedId = obj.id;
      this.preloadImage(obj.image);
      this.save();
      this.draw();
      this.updateSummary();
    }

    productKind(search) {
      if (/terrarium|gewächshaus|growzelt|pflanzenregal|station/.test(search)) return 'system';
      if (/regal|grove|bar|tube|unterbau/.test(search)) return 'shelf-light';
      if (/pendel|pendant|wand|aspect|luna/.test(search)) return 'pendant';
      if (/stand|willow|stello|alta|teleskop/.test(search)) return 'floor-light';
      if (/aquascap|wasserpflanz|sera|daytime/.test(search)) return 'habitat';
      return 'light';
    }

    productPreset(kind) {
      const presets = {
        system: {width: 1.25, depth: .72, height: 1.75, color: '#6f7f72'},
        'shelf-light': {width: 1.15, depth: .38, height: 1.55, color: '#78936e'},
        pendant: {width: .45, depth: .45, height: 2.0, color: '#b9a76f'},
        'floor-light': {width: .52, depth: .52, height: 1.85, color: '#9d916f'},
        habitat: {width: 1.0, depth: .55, height: 1.0, color: '#587d83'},
        light: {width: .42, depth: .42, height: 1.65, color: '#a39d73'}
      };
      return presets[kind] || presets.light;
    }

    preloadImage(url) {
      if (!url || this.productImages.has(url)) return;
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => this.draw();
      img.src = url;
      this.productImages.set(url, img);
    }

    clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    clampObject(obj) {
      const halfW = this.room.width / 2;
      const halfD = this.room.depth / 2;
      obj.x = this.clamp(obj.x, -halfW + .15, halfW - .15);
      obj.z = this.clamp(obj.z, -halfD + .15, halfD - .15);
    }

    clampObjects() {
      this.objects.forEach((obj) => this.clampObject(obj));
    }

    metrics() {
      const w = this.canvas.width;
      const h = this.canvas.height;
      const scale = Math.min(w / (this.room.width + this.room.depth + 2), h / (this.room.depth + this.room.height + 2)) * 1.35;
      return {w, h, scale, ox: w * .5, oy: h * .69};
    }

    project(x, y, z) {
      const {scale, ox, oy} = this.metrics();
      const a = this.camera * Math.PI / 180;
      const c = Math.cos(a);
      const s = Math.sin(a);
      const xr = x * c - z * s;
      const zr = x * s + z * c;
      return {
        x: ox + xr * scale,
        y: oy + zr * scale * .48 - y * scale * .88
      };
    }

    localPoint(obj, x, z) {
      const angle = obj.rotation * Math.PI / 180;
      const c = Math.cos(angle);
      const s = Math.sin(angle);
      return {
        x: obj.x + x * c - z * s,
        z: obj.z + x * s + z * c
      };
    }

    roomFloorPoints() {
      const hw = this.room.width / 2;
      const hd = this.room.depth / 2;
      return [
        this.project(-hw, 0, -hd),
        this.project(hw, 0, -hd),
        this.project(hw, 0, hd),
        this.project(-hw, 0, hd)
      ];
    }

    polygon(points, fill, stroke = null, width = 1) {
      const ctx = this.ctx;
      ctx.beginPath();
      points.forEach((p, index) => index ? ctx.lineTo(p.x, p.y) : ctx.moveTo(p.x, p.y));
      ctx.closePath();
      if (fill) {
        ctx.fillStyle = fill;
        ctx.fill();
      }
      if (stroke) {
        ctx.lineWidth = width;
        ctx.strokeStyle = stroke;
        ctx.stroke();
      }
    }

    drawRoom() {
      const ctx = this.ctx;
      const floor = this.roomFloorPoints();
      this.polygon(floor, '#f2f2ec', '#819087', Math.max(1, this.canvas.width / 1400));

      const grid = .5;
      const hw = this.room.width / 2;
      const hd = this.room.depth / 2;
      ctx.save();
      ctx.strokeStyle = 'rgba(67, 91, 77, .13)';
      ctx.lineWidth = Math.max(1, this.canvas.width / 1800);
      for (let x = -hw; x <= hw + .001; x += grid) {
        const a = this.project(x, 0, -hd);
        const b = this.project(x, 0, hd);
        ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      }
      for (let z = -hd; z <= hd + .001; z += grid) {
        const a = this.project(-hw, 0, z);
        const b = this.project(hw, 0, z);
        ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      }
      ctx.restore();

      const backLeft = this.project(-hw, 0, -hd);
      const backRight = this.project(hw, 0, -hd);
      const backLeftTop = this.project(-hw, this.room.height, -hd);
      const backRightTop = this.project(hw, this.room.height, -hd);
      this.polygon([backLeft, backRight, backRightTop, backLeftTop], 'rgba(232,236,228,.75)', 'rgba(92,112,100,.25)');

      const sideBottom = this.project(-hw, 0, hd);
      const sideTop = this.project(-hw, this.room.height, hd);
      this.polygon([backLeft, sideBottom, sideTop, backLeftTop], 'rgba(224,231,222,.62)', 'rgba(92,112,100,.2)');

      ctx.fillStyle = 'rgba(42,61,51,.68)';
      ctx.font = `${Math.max(12, this.canvas.width / 95)}px system-ui, sans-serif`;
      ctx.fillText(`${this.room.width.toFixed(1)} m × ${this.room.depth.toFixed(1)} m × ${this.room.height.toFixed(1)} m`, floor[3].x + 10, floor[3].y + 24);
    }

    drawPrism(obj, fill = obj.color) {
      const hw = obj.width / 2;
      const hd = obj.depth / 2;
      const baseLocal = [[-hw,-hd],[hw,-hd],[hw,hd],[-hw,hd]];
      const base = baseLocal.map(([x,z]) => {
        const p = this.localPoint(obj,x,z);
        return this.project(p.x,0,p.z);
      });
      const top = baseLocal.map(([x,z]) => {
        const p = this.localPoint(obj,x,z);
        return this.project(p.x,obj.height,p.z);
      });
      this.polygon([base[1],base[2],top[2],top[1]], this.shade(fill,-14));
      this.polygon([base[2],base[3],top[3],top[2]], this.shade(fill,-24));
      this.polygon(top, fill, 'rgba(30,45,37,.24)');
      return this.project(obj.x,obj.height,obj.z);
    }

    shade(hex, amount) {
      const raw = hex.replace('#','');
      if (raw.length !== 6) return hex;
      const num = parseInt(raw,16);
      const r = this.clamp((num >> 16) + amount,0,255);
      const g = this.clamp(((num >> 8) & 255) + amount,0,255);
      const b = this.clamp((num & 255) + amount,0,255);
      return `rgb(${r}, ${g}, ${b})`;
    }

    drawPlant(obj) {
      const pot = {...obj, width: obj.width * .55, depth: obj.depth * .55, height: .32, color: '#8b6f55'};
      const top = this.drawPrism(pot, pot.color);
      const ctx = this.ctx;
      const stemTop = this.project(obj.x, obj.height * .78, obj.z);
      ctx.strokeStyle = '#4c7047';
      ctx.lineWidth = Math.max(2, this.canvas.width / 600);
      ctx.beginPath(); ctx.moveTo(top.x, top.y); ctx.lineTo(stemTop.x, stemTop.y); ctx.stroke();
      const size = Math.max(10, this.metrics().scale * .23);
      [['#557b4f',0,0],['#6d8f60',-.55,-.15],['#486c46',.55,-.05],['#73986b',0,.48]].forEach(([color,dx,dy]) => {
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.ellipse(stemTop.x + Number(dx)*size, stemTop.y + Number(dy)*size, size*.52, size*.32, -.45, 0, Math.PI*2);
        ctx.fill();
      });
      return stemTop;
    }

    drawLight(obj) {
      const ctx = this.ctx;
      const base = {...obj, width: .34, depth: .34, height: .08, color: '#77756a'};
      this.drawPrism(base, base.color);
      const bottom = this.project(obj.x,.08,obj.z);
      const top = this.project(obj.x,obj.height,obj.z);
      ctx.strokeStyle = '#68685f';
      ctx.lineWidth = Math.max(2,this.canvas.width/700);
      ctx.beginPath(); ctx.moveTo(bottom.x,bottom.y); ctx.lineTo(top.x,top.y); ctx.stroke();
      const lamp = this.project(obj.x,obj.height-.08,obj.z);
      const coneFloor = this.project(obj.x,0,obj.z);
      const radius = Math.max(18, this.metrics().scale * (.36 + Math.min(obj.watts,60)/180));
      ctx.save();
      ctx.fillStyle = 'rgba(238, 212, 112, .11)';
      ctx.beginPath();
      ctx.moveTo(lamp.x,lamp.y);
      ctx.lineTo(coneFloor.x-radius,coneFloor.y);
      ctx.lineTo(coneFloor.x+radius,coneFloor.y);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
      ctx.fillStyle = '#c7b96f';
      ctx.beginPath(); ctx.arc(lamp.x,lamp.y,Math.max(6,this.metrics().scale*.08),0,Math.PI*2); ctx.fill();
      return lamp;
    }

    drawWindow(obj) {
      const p = this.project(obj.x,obj.height*.6,obj.z);
      const ctx = this.ctx;
      const scale = this.metrics().scale;
      const w = obj.width * scale * .45;
      const h = obj.height * scale * .42;
      ctx.fillStyle = 'rgba(164, 205, 214, .54)';
      ctx.fillRect(p.x-w/2,p.y-h,w,h);
      ctx.strokeStyle = 'rgba(73,112,120,.7)';
      ctx.strokeRect(p.x-w/2,p.y-h,w,h);
      ctx.beginPath(); ctx.moveTo(p.x,p.y-h);ctx.lineTo(p.x,p.y);ctx.moveTo(p.x-w/2,p.y-h/2);ctx.lineTo(p.x+w/2,p.y-h/2);ctx.stroke();
      return p;
    }

    drawObject(obj) {
      let anchor;
      if (obj.kind === 'plant') anchor = this.drawPlant(obj);
      else if (obj.kind === 'window') anchor = this.drawWindow(obj);
      else if (['light','floor-light','pendant','shelf-light'].includes(obj.kind)) anchor = this.drawLight(obj);
      else anchor = this.drawPrism(obj);

      obj.screen = {x: anchor.x, y: anchor.y};
      if (obj.image) {
        this.preloadImage(obj.image);
        const img = this.productImages.get(obj.image);
        if (img?.complete) {
          const size = Math.max(24, Math.min(46, this.canvas.width / 28));
          this.ctx.save();
          this.ctx.globalAlpha = .94;
          this.ctx.fillStyle = '#fff';
          this.ctx.fillRect(anchor.x-size/2,anchor.y-size-12,size,size);
          try { this.ctx.drawImage(img,anchor.x-size/2+2,anchor.y-size-10,size-4,size-4); } catch {}
          this.ctx.restore();
        }
      }

      if (obj.id === this.selectedId) {
        const radius = Math.max(18,this.metrics().scale*.24);
        const floor = this.project(obj.x,0,obj.z);
        this.ctx.strokeStyle = '#315c3d';
        this.ctx.lineWidth = Math.max(2,this.canvas.width/700);
        this.ctx.setLineDash([7,5]);
        this.ctx.beginPath(); this.ctx.arc(floor.x,floor.y,radius,0,Math.PI*2); this.ctx.stroke();
        this.ctx.setLineDash([]);
      }

      this.ctx.fillStyle = 'rgba(31,49,39,.88)';
      this.ctx.font = `600 ${Math.max(10,this.canvas.width/125)}px system-ui, sans-serif`;
      const label = obj.title.length > 28 ? `${obj.title.slice(0,27)}…` : obj.title;
      this.ctx.fillText(label, anchor.x + 8, anchor.y - 4);
    }

    draw() {
      if (!this.ctx) return;
      const ctx = this.ctx;
      ctx.clearRect(0,0,this.canvas.width,this.canvas.height);
      const gradient = ctx.createLinearGradient(0,0,0,this.canvas.height);
      gradient.addColorStop(0,'#f6f7f3');
      gradient.addColorStop(1,'#e8eee7');
      ctx.fillStyle = gradient;
      ctx.fillRect(0,0,this.canvas.width,this.canvas.height);
      this.drawRoom();

      const sorted = [...this.objects].sort((a,b) => {
        const pa = this.project(a.x,0,a.z);
        const pb = this.project(b.x,0,b.z);
        return pa.y - pb.y;
      });
      sorted.forEach((obj) => this.drawObject(obj));
      this.updateSelection();
    }

    pointerPosition(event) {
      const rect = this.canvas.getBoundingClientRect();
      return {
        x: (event.clientX - rect.left) * (this.canvas.width / rect.width),
        y: (event.clientY - rect.top) * (this.canvas.height / rect.height)
      };
    }

    hitTest(point) {
      let best = null;
      let bestDistance = Infinity;
      this.objects.forEach((obj) => {
        const p = obj.screen || this.project(obj.x,obj.height,obj.z);
        const distance = Math.hypot(point.x-p.x,point.y-p.y);
        const threshold = Math.max(28,this.metrics().scale*.35);
        if (distance < threshold && distance < bestDistance) {
          best = obj;
          bestDistance = distance;
        }
      });
      return best;
    }

    pointerDown(event) {
      const point = this.pointerPosition(event);
      const obj = this.hitTest(point);
      if (!obj) {
        this.selectedId = null;
        this.draw();
        return;
      }
      this.selectedId = obj.id;
      this.drag = {last: point, id: obj.id};
      this.canvas.setPointerCapture?.(event.pointerId);
      this.draw();
    }

    pointerMove(event) {
      if (!this.drag) return;
      const obj = this.objects.find((item) => item.id === this.drag.id);
      if (!obj) return;
      const point = this.pointerPosition(event);
      const dx = point.x - this.drag.last.x;
      const dy = point.y - this.drag.last.y;
      const {scale} = this.metrics();
      const a = this.camera * Math.PI / 180;
      const c = Math.cos(a);
      const s = Math.sin(a);
      const dxr = dx / scale;
      const dzr = dy / (scale * .48);
      obj.x += dxr * c + dzr * s;
      obj.z += -dxr * s + dzr * c;
      this.clampObject(obj);
      this.drag.last = point;
      this.draw();
      this.updateSummary();
    }

    pointerUp() {
      if (this.drag) this.save();
      this.drag = null;
    }

    selected() {
      return this.objects.find((obj) => obj.id === this.selectedId) || null;
    }

    rotateSelected(delta) {
      const obj = this.selected();
      if (!obj) return;
      obj.rotation = (obj.rotation + delta + 360) % 360;
      this.save();
      this.draw();
    }

    deleteSelected() {
      if (!this.selectedId) return;
      this.objects = this.objects.filter((obj) => obj.id !== this.selectedId);
      this.selectedId = null;
      this.save();
      this.draw();
      this.updateSummary();
    }

    duplicateSelected() {
      const obj = this.selected();
      if (!obj) return;
      const copy = {...obj, id: ++this.objectId, x: obj.x + .25, z: obj.z + .25};
      delete copy.screen;
      this.clampObject(copy);
      this.objects.push(copy);
      this.selectedId = copy.id;
      this.save();
      this.draw();
      this.updateSummary();
    }

    updateSelection() {
      const panel = this.querySelector('[data-selection]');
      const obj = this.selected();
      if (!panel) return;
      panel.hidden = !obj;
      if (!obj) return;
      const title = panel.querySelector('[data-selection-title]');
      const meta = panel.querySelector('[data-selection-meta]');
      if (title) title.textContent = obj.title;
      if (meta) {
        const parts = [`${obj.x.toFixed(1)} × ${obj.z.toFixed(1)} m`, `${obj.rotation}°`];
        if (obj.watts) parts.push(`${obj.watts} W`);
        meta.textContent = parts.join(' · ');
      }
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(this.locale,{style:'currency',currency:this.currency}).format(cents/100);
      } catch {
        return `${(cents/100).toFixed(2)} €`;
      }
    }

    updateSummary() {
      const productObjects = this.objects.filter((obj) => obj.variantId);
      const total = productObjects.reduce((sum,obj) => sum + Number(obj.price || 0),0);
      const watts = productObjects.reduce((sum,obj) => sum + Number(obj.watts || 0),0);
      const area = Math.max(.1,this.room.width*this.room.depth);
      const count = this.querySelector('[data-summary-count]');
      const price = this.querySelector('[data-summary-price]');
      const power = this.querySelector('[data-summary-watts]');
      const density = this.querySelector('[data-summary-density]');
      const cart = this.querySelector('[data-add-setup]');
      if (count) count.textContent = String(this.objects.length);
      if (price) price.textContent = productObjects.length ? this.formatMoney(total) : '—';
      if (power) power.textContent = `${Math.round(watts)} W`;
      if (density) density.textContent = `${(watts/area).toFixed(1)} W/m²`;
      if (cart) cart.disabled = productObjects.length === 0;
    }

    async addSetupToCart() {
      const button = this.querySelector('[data-add-setup]');
      const status = this.querySelector('[data-builder-status]');
      const products = this.objects.filter((obj) => obj.variantId);
      if (!products.length || !button) return;
      const grouped = new Map();
      products.forEach((obj) => grouped.set(obj.variantId,(grouped.get(obj.variantId)||0)+1));
      const items = [...grouped.entries()].map(([id,quantity]) => ({id,quantity}));
      button.disabled = true;
      if (status) status.textContent = '';
      try {
        const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        if (!response.ok) throw new Error('cart');
        if (status) status.textContent = this.dataset.addedLabel || '';
        window.setTimeout(() => {
          window.location.href = this.dataset.cartUrl || '/cart';
        },500);
      } catch {
        if (status) status.textContent = this.dataset.errorLabel || '';
        button.disabled = false;
      }
    }

    save() {
      try {
        localStorage.setItem('leafer-interieur-room-v1',JSON.stringify({
          room:this.room,
          camera:this.camera,
          objects:this.objects.map(({screen,...obj}) => obj),
          objectId:this.objectId
        }));
      } catch {}
    }

    restore() {
      try {
        const raw = localStorage.getItem('leafer-interieur-room-v1');
        if (!raw) return;
        const saved = JSON.parse(raw);
        if (saved?.room) {
          this.room = {...this.room,...saved.room};
          ['width','depth','height'].forEach((key) => {
            const input = this.querySelector(`[data-room-${key}]`);
            if (input) input.value = this.room[key];
          });
        }
        if (Number.isFinite(saved?.camera)) this.camera = saved.camera;
        if (Array.isArray(saved?.objects)) {
          this.objects = saved.objects.slice(0,40);
          this.objects.forEach((obj) => this.preloadImage(obj.image));
        }
        if (Number.isFinite(saved?.objectId)) this.objectId = saved.objectId;
      } catch {}
    }

    reset() {
      try { localStorage.removeItem('leafer-interieur-room-v1'); } catch {}
      this.room = {width:4.2,depth:3.2,height:2.5};
      this.camera = -35;
      this.objects = [];
      this.selectedId = null;
      this.objectId = 0;
      ['width','depth','height'].forEach((key) => {
        const input = this.querySelector(`[data-room-${key}]`);
        if (input) input.value = this.room[key];
      });
      this.addPrimitive('plant',-.75,.2);
      this.addPrimitive('plant',.55,.55);
      this.save();
      this.draw();
      this.updateSummary();
    }
  }

  if (!customElements.get('interieur-room-builder')) {
    customElements.define('interieur-room-builder',InterieurRoomBuilder);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductPurchase extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-product-variant]');
      if (!this.select) return;
      this.handleChange = () => this.updateVariant(true);
      this.select.addEventListener('change', this.handleChange);
      this.updateVariant(false);
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.handleChange);
    }

    updateVariant(updateUrl) {
      const option = this.select?.selectedOptions?.[0];
      const section = this.closest('.main-product');
      if (!option || !section) return;

      const available = option.dataset.available === 'true';
      const compareAt = option.dataset.compareAt || '';
      const unitPrice = option.dataset.unitPrice || '';
      const sku = option.dataset.sku || '';

      section.querySelectorAll('[data-product-price]').forEach((element) => { element.textContent = option.dataset.price || ''; });
      section.querySelectorAll('[data-product-compare]').forEach((element) => {
        element.textContent = compareAt;
        element.hidden = !compareAt;
      });
      section.querySelectorAll('[data-product-unit-price]').forEach((element) => {
        element.textContent = unitPrice;
        element.hidden = !unitPrice;
      });
      section.querySelectorAll('[data-product-sku]').forEach((element) => { element.textContent = sku; });
      section.querySelectorAll('[data-product-sku-row]').forEach((element) => { element.hidden = !sku; });

      section.querySelectorAll('[data-product-availability]').forEach((element) => {
        element.textContent = available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
        element.classList.toggle('is-unavailable', !available);
      });

      const passDownload = section.querySelector('[data-product-pass-download]');
      const passLink = section.querySelector('[data-product-pass-link]');
      const passUrl = option.dataset.passUrl || '';
      if (passDownload && passLink) {
        passLink.href = passUrl;
        passDownload.hidden = !passUrl;
      }

      section.querySelectorAll('[data-product-submit]').forEach((button) => {
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
        button.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      });

      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }

      this.dispatchEvent(new CustomEvent('product:variant-change', {
        bubbles: true,
        detail: { variantId: option.value, available }
      }));
    }
  }

  if (!customElements.get('product-purchase')) customElements.define('product-purchase', ProductPurchase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obstgenerator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '').trim().toLocaleLowerCase();

    const init = (root) => {
      if (!root || root.dataset.leaferFruitReady === 'true') return;
      root.dataset.leaferFruitReady = 'true';

      const variantInput = root.querySelector('[data-variant-input]');
      const price = root.querySelector('[data-product-price]');
      const availability = root.querySelector('[data-availability]');
      const addButton = root.querySelector('[data-add-button]');
      const addLabel = root.querySelector('[data-add-label]');
      const radios = [...root.querySelectorAll('[data-variant-radio]')];
      const varietyButtons = [...root.querySelectorAll('[data-variety-select]')];

      const updateVariant = (radio) => {
        if (!radio || !variantInput) return;
        const available = radio.dataset.available === 'true';
        const render = () => {
          variantInput.value = radio.value;
          if (price) price.textContent = radio.dataset.price;
          if (availability) {
            availability.textContent = available
              ? radio.dataset.availableLabel
              : radio.dataset.soldOutLabel;
          }
          if (addButton) addButton.disabled = !available;
          if (addLabel) {
            addLabel.textContent = available
              ? radio.dataset.addButtonLabel
              : radio.dataset.soldOutLabel;
          }
          varietyButtons.forEach((button) => {
            const active = normalize(button.dataset.variantTitle) === normalize(radio.dataset.variantTitle);
            button.setAttribute('aria-pressed', String(active));
          });
        };

        if (document.startViewTransition) {
          document.startViewTransition(render);
        } else {
          render();
        }
      };

      radios.forEach((radio) => {
        radio.addEventListener('change', () => updateVariant(radio));
      });

      varietyButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const match = radios.find(
            (radio) => normalize(radio.dataset.variantTitle) === normalize(button.dataset.variantTitle)
          );
          if (!match || match.disabled) return;
          match.checked = true;
          match.dispatchEvent(new Event('change', { bubbles: true }));
          root.querySelector('.leafer-fruit__buybox')?.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'center'
          });
        });
      });

      const quantityInput = root.querySelector('[data-quantity-input]');
      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
      });
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
      });

      root.querySelector('[data-scroll-to-form]')?.addEventListener('click', (event) => {
        const target = document.getElementById(event.currentTarget.dataset.formTarget);
        if (!target) return;
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
        window.setTimeout(() => target.querySelector('input:not([type="hidden"]), button')?.focus(), 450);
      });

      updateVariant(radios.find((radio) => radio.checked) || radios.find((radio) => !radio.disabled));
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-leafer-fruit]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-variant-description"] && !Shopify.designMode) return;
  try {
    
  class ProductVariantDescription extends HTMLElement {
    connectedCallback() {
      this.variantSelect = document.querySelector('product-purchase select[name="id"]');
      this.handleVariantChange = () => this.update(this.variantSelect.value);
      this.variantSelect?.addEventListener('change', this.handleVariantChange);
      this.update(this.variantSelect?.value || this.dataset.initialVariant);
    }

    disconnectedCallback() {
      this.variantSelect?.removeEventListener('change', this.handleVariantChange);
    }

    update(variantId) {
      let hasMatch = false;

      this.querySelectorAll('[data-variant-description]').forEach((article) => {
        const isMatch = article.dataset.variantId === String(variantId);
        article.hidden = !isMatch;
        hasMatch = hasMatch || isMatch;
      });

      this.hidden = !hasMatch;
    }
  }

  if (!customElements.get('product-variant-description')) {
    customElements.define('product-variant-description', ProductVariantDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["substrate-configurator"] && !Shopify.designMode) return;
  try {
    
  class SubstrateConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.parts = [...this.querySelectorAll('[data-mix-part]')];
      this.colors = ['#c49363', '#b8c89a', '#eee9dc', '#a87954', '#846b5b', '#9fb7a3', '#d7bf84', '#a4a0bc'];

      this.parts.forEach((part, index) => {
        part.closest('label')?.style.setProperty('--mix-color', this.colors[index % this.colors.length]);
        part.addEventListener('input', () => this.rebalance(part));
      });
      this.querySelector('[data-copy]')?.addEventListener('click', () => this.copy());

      this.normalizeInitial();
      this.update();
    }

    allocate(total, weights) {
      if (!weights.length) return [];
      const sum = weights.reduce((acc, value) => acc + Math.max(0, value), 0);
      const raw = sum > 0
        ? weights.map((value) => (Math.max(0, value) / sum) * total)
        : weights.map(() => total / weights.length);
      const values = raw.map((value) => Math.floor(value));
      let remainder = total - values.reduce((acc, value) => acc + value, 0);
      const order = raw
        .map((value, index) => ({ index, fraction: value - Math.floor(value) }))
        .sort((a, b) => b.fraction - a.fraction);
      for (let index = 0; index < remainder; index += 1) values[order[index % order.length].index] += 1;
      return values;
    }

    normalizeInitial() {
      const values = this.parts.map((part) => Number(part.value));
      const total = values.reduce((sum, value) => sum + value, 0);
      if (total === 100) return;
      const normalized = this.allocate(100, values);
      this.parts.forEach((part, index) => { part.value = normalized[index]; });
    }

    rebalance(changed) {
      const changedValue = Math.max(0, Math.min(100, Math.round(Number(changed.value))));
      changed.value = changedValue;
      const others = this.parts.filter((part) => part !== changed);
      const allocated = this.allocate(100 - changedValue, others.map((part) => Number(part.value)));
      others.forEach((part, index) => { part.value = allocated[index]; });
      this.update();
    }

    update() {
      let total = 0;
      let cursor = 0;
      const recipe = [];
      const stops = [];
      const legend = this.querySelector('[data-pie-legend]');
      if (legend) legend.replaceChildren();

      this.parts.forEach((part, index) => {
        const value = Number(part.value);
        const color = this.colors[index % this.colors.length];
        const start = cursor;
        const end = cursor + value;
        cursor = end;
        total += value;
        part.closest('label')?.querySelector('output')?.replaceChildren(document.createTextNode(`${value}%`));
        if (value > 0) {
          recipe.push(`${value} % ${part.dataset.name}`);
          stops.push(`${color} ${start}% ${end}%`);
        }

        if (legend && value > 0) {
          const row = document.createElement('div');
          row.className = 'substrate-configurator__legend-row';
          const dot = document.createElement('span');
          dot.className = 'substrate-configurator__legend-dot';
          dot.style.background = color;
          const name = document.createElement('span');
          name.textContent = part.dataset.name;
          const amount = document.createElement('b');
          amount.textContent = `${value}%`;
          row.append(dot, name, amount);
          legend.append(row);
        }
      });

      const recipeText = recipe.join(' · ');
      const pie = this.querySelector('[data-pie]');
      if (pie) {
        pie.style.background = stops.length ? `conic-gradient(${stops.join(', ')})` : 'transparent';
        pie.setAttribute('aria-label', recipeText);
      }

      this.querySelector('[data-total]').textContent = `${this.dataset.totalLabel}: ${total}%`;
      this.querySelector('[data-total-short]').textContent = `${total}%`;
      this.querySelector('[data-status]').textContent = total === 100 ? this.dataset.validLabel : this.dataset.invalidLabel;
      this.querySelector('[data-recipe]').value = recipeText;
      this.dispatchEvent(new CustomEvent('substrate:change', { bubbles: true, detail: { total, recipe: recipeText } }));

      const creator = document.querySelector('custom-grow-creator');
      if (creator && typeof creator.updateRecipe === 'function') creator.updateRecipe();
    }

    async copy() {
      const field = this.querySelector('[data-recipe]');
      if (!field?.value) return;

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(field.value);
        } else {
          field.classList.remove('visually-hidden');
          field.select();
          document.execCommand('copy');
          field.classList.add('visually-hidden');
        }
        this.querySelector('[data-status]').textContent = this.dataset.copiedLabel;
      } catch (error) {
        this.querySelector('[data-status]').textContent = this.dataset.validLabel;
      }
    }
  }

  if (!customElements.get('substrate-configurator')) customElements.define('substrate-configurator', SubstrateConfigurator);

  } catch(e) { console.error(e); }
})();
})();
